import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import GroupInput from "../../../../Components/GroupInput";
import ErrorContainer from "../../../../Components/ErrorContainer";
import {
  capitalizeFirstLetter,
  changeDateFormat,
  checkArray,
  checkNull,
  createMultiSelectOptions,
  createSelectOptions,
  createSelectTwoOptions,
  createYesNoSelectOptions,
  decimalValue,
  deepCopy,
  getMerchantCurrencySymbol,
  groupByArray,
  pluckArray,
  getRandomString,
} from "../../../../../helpers";
import { useDispatch, useSelector } from "react-redux";
import GroupSelect from "../../../../Components/GroupSelect";
import GroupTextArea from "../../../../Components/GroupTextArea";
import GroupColorInput from "../../../../Components/GroupColorInput";
import GroupMultiSelect from "../../../../Components/GroupMultiSelect";
import GroupMultiInput from "../../../../Components/GroupMultiInput";
import {
  changeMenuValue,
  deleteEditMenuPricings,
  deleteMenuPricings,
  getAddMenuItem,
  getAddMenuPricings,
  getCostPerItem,
  getEditMenuEditPricings,
  getEditMenuItem,
  getEditMenuPricings,
  getMenuEditPricings,
  getMenuItemCa,
  getMenuItemSubCategory,
  getMenuItemSubClass,
  getMenuMeasurementUnit,
  getMenuMultiUnit,
  getMenusList,
  getMenuUnitPrice,
  menuInitialValue,
  saveAddMenuItem,
  saveAddMenuPricings,
  saveEditMenuPricings,
  saveStorageAreaDetails,
} from "../../../../../Redux/actions";
import ModelContainer from "../../../../Components/ModelContainer";
import GroupSelectTwo from "../../../../Components/GroupSelectTwo";
import GroupDate from "../../../../Components/GroupDate";
import moment from "moment";
import GroupCheckbox from "../../../../Components/GroupCheckbox";
import { arrayMoveImmutable } from "array-move";

const MenuItem = (props) => {
  const { id } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const user_details = useSelector((state) => state.authReducer.user_details);
  const {
    add_item_details,
    item_subclass_detail,
    componentItemModal,
    item_ca_details,
    measurement_unit_details,
    serviceItemModal,
    priceItemModal,
    saved_pricings_details,
    edit_pricings_details,
    bundledOptionsModal,
    is_redirect_flag,
    item_subcategory_detail,
    menu_item_list,
    cost_per_item,
    storageAreaModalModal,
    add_storage_new_id,
    is_add_storage_loading,
  } = useSelector((state) => state.menuReducer);

  useEffect(() => {
    dispatch(getEditMenuItem(`/${id}`));
    return () => {
      dispatch(menuInitialValue());
    };
  }, []);
  useEffect(() => {
    if (is_redirect_flag) {
      history.push("/menu/items");
    }
  }, [is_redirect_flag]);

  useEffect(() => {
    if (checkNull(add_item_details?.menu_item, false)) {
      const menuItemObj = add_item_details?.menu_item;
      let defaultPeriodArr = [];
      // applicable period:
      if (checkArray(menuItemObj?.PosApplicablePeriod)) {
        defaultPeriodArr = menuItemObj?.PosApplicablePeriod.map((period) => {
          let applicableDaysArr = [];
          if (checkArray(period?.applicable_days)) {
            applicableDaysArr = period?.applicable_days
              .filter(
                (p) => add_item_details?.weekly?.[parseInt(p)] !== undefined
              )
              .map((periodDay) => {
                const weeklyIndx =
                  add_item_details?.weekly?.[parseInt(periodDay)];
                return {
                  label: weeklyIndx,
                  value: parseInt(periodDay),
                };
              });
          }
          return {
            id: period?.id ?? "",
            is_checked: period?.is_checked == 1 ? true : false,
            service_period_id: period?.service_period?.id,
            applicable_days: applicableDaysArr,
          };
        });
      }
      // service period
      let defaultPeriodDay = [];
      if (checkArray(menuItemObj?.pos_service_period)) {
        defaultPeriodDay = menuItemObj?.pos_service_period.map((posService) => {
          return {
            id: posService?.id ?? "",
            period_start: checkNull(posService?.period_start, false)
              ? moment(posService?.period_start).toDate()
              : "",
            period_end: checkNull(posService?.period_end, false)
              ? moment(posService?.period_end).toDate()
              : "",
          };
        });
      }
      // component item
      let componentItemArr = [];
      if (checkArray(menuItemObj?.component_list_item)) {
        componentItemArr = menuItemObj?.component_list_item.map(
          (componentItem) => {
            return {
              id: checkNull(componentItem?.id),
              amount_used: checkNull(componentItem?.amount_used_unit_price, 0),
              amount_used_unit_price: checkNull(
                componentItem?.amount_used_unit_price,
                ""
              ),
              category_id: checkNull(componentItem?.category_id, ""),
              ingredient_id: checkNull(componentItem?.ingredient_id, ""),
              item_component_cost: checkNull(
                componentItem?.item_component_cost,
                0
              ),
              item_type: checkNull(componentItem?.item_type, ""),
              measurement_choice_id: checkNull(
                componentItem?.measurement_choice_id,
                ""
              ),
              measurement_unit_id: checkNull(
                componentItem?.measurement_unit_id,
                ""
              ),
              number_of_servings: checkNull(
                componentItem?.number_of_servings,
                0
              ),
              other_category_id: checkNull(
                componentItem?.other_category_id,
                ""
              ),
              proportion: checkNull(componentItem?.proportion, 0),
              recipe_id: checkNull(componentItem?.recipe_id, ""),
              temp_amount_used: checkNull(
                componentItem?.conversion_multiplier,
                0
              ),
              temp_measurement_unit_id: checkNull(
                componentItem?.temp_measurement_unit_id,
                ""
              ),
              temp_unit_price: checkNull(componentItem?.temp_unit_price, 0),
              unit_amount: checkNull(componentItem?.unit_amount, 0),
              unit_price: checkNull(componentItem?.amount_used_unit_price, 0),
            };
          }
        );
      }
      // bundle option item
      let bundleOptionItemArr = [];
      if (checkArray(menuItemObj?.bundled_option_series)) {
        bundleOptionItemArr = menuItemObj?.bundled_option_series.map(
          (bundleOptionItem) => {
            const bundleItemsArr = checkArray(
              bundleOptionItem?.bundled_menu_item
            )
              ? bundleOptionItem?.bundled_menu_item.map((bunMenItm) => {
                  return {
                    amount: checkNull(bunMenItm?.unit_cost, 0),
                    label: checkNull(bunMenItm?.menu_item2?.menu_item_name),
                    total_amount:
                      checkNull(bunMenItm?.unit_cost, false) &&
                      checkNull(bunMenItm?.quantity, false)
                        ? parseFloat(bunMenItm?.unit_cost * bunMenItm?.quantity)
                        : 0,
                    value: checkNull(bunMenItm?.bundle_menu_item_id),
                  };
                })
              : [];
            const bundleMenusArr = checkArray(
              bundleOptionItem?.bundled_menu_item
            )
              ? bundleOptionItem?.bundled_menu_item.map((bunMenItm) => {
                  return {
                    id: checkNull(bunMenItm?.id),
                    action_price: checkNull(bunMenItm?.action_price),
                    amount: checkNull(bunMenItm?.amount),
                    bundle_menu_item_id: checkNull(
                      bunMenItm?.bundle_menu_item_id
                    ),
                    category_id: checkNull(bunMenItm?.category_id),
                    item_name: checkNull(bunMenItm?.menu_item2?.menu_item_name),
                    modifier_availability: checkNull(
                      bunMenItm?.modifier_availability
                    ),
                    offlineId: getRandomString(),
                    option_series_name: checkNull(
                      bunMenItm?.option_series_name
                    ),
                    quantity: checkNull(bunMenItm?.quantity),
                    sort: checkNull(bunMenItm?.unit_cost, 0),
                    sub_category_id: checkNull(bunMenItm?.sub_category_id),
                    total_unit_cost: checkNull(bunMenItm?.unit_cost, 0),
                    unit_cost: checkNull(bunMenItm?.unit_cost, 0),
                  };
                })
              : [];
            const firstItem = bundleOptionItem?.bundled_menu_item?.[0];
            return {
              id: checkNull(bundleOptionItem?.id),
              action_price: checkNull(firstItem?.action_price),
              amount: checkNull(firstItem?.amount),
              bundle_menu_item_id: bundleItemsArr,
              bundled_menu_item: bundleMenusArr,
              category_id: checkNull(firstItem?.category_id),
              modifier_availability: checkNull(
                firstItem?.modifier_availability
              ),
              option_series: checkNull(bundleOptionItem?.name),
              option_series_name: checkNull(bundleOptionItem?.name),
              option_series_type: checkNull(
                bundleOptionItem?.option_series_type
              ),
              quantity: checkNull(firstItem?.quantity, 0),
              sort: checkNull(bundleOptionItem?.sort, 0),
              sub_category_id: checkNull(firstItem?.sub_category_id),
              unit_cost: checkNull(bundleOptionItem?.unit_cost, 0),
            };
          }
        );
      }
      const editItemObj = {
        id: id,
        menu_item_name: checkNull(menuItemObj?.menu_item_name),
        menu_item_type: checkNull(menuItemObj?.menu_item_type),
        menu_class_id: checkNull(menuItemObj?.menu_class_id),
        sub_class_id: checkNull(menuItemObj?.sub_class_id),
        is_production_item: checkNull(menuItemObj?.is_production_item),
        storage_area_1_id: checkNull(menuItemObj?.storage_area_1_id),
        storage_area_2_id: checkNull(menuItemObj?.storage_area_2_id),
        pos_name: checkNull(menuItemObj?.pos_name),
        other_category_id: checkNull(menuItemObj?.other_category_id),
        sub_category_id: checkNull(menuItemObj?.sub_category_id),
        description: checkNull(menuItemObj?.description),
        allow_price_override: checkNull(menuItemObj?.allow_price_override),
        pos_color: checkNull(menuItemObj?.pos_color),
        kitchen_print_preference: checkNull(
          menuItemObj?.kitchen_print_preference
        ),
        scan_by: checkNull(menuItemObj?.scan_by),
        sku_code: checkNull(menuItemObj?.sku_code),
        allergy_tags: checkArray(menuItemObj?.allergy_tags)
          ? menuItemObj?.allergy_tags
          : [],
        key_words: checkNull(menuItemObj?.key_words, false)
          ? menuItemObj?.key_words.split(",")
          : [],
        total_cost_per_menu_item: checkNull(
          menuItemObj?.total_cost_per_menu_item
        ),
        hide_fixed_items: checkNull(menuItemObj?.hide_fixed_items),
        pos_applicable_period: defaultPeriodArr,
        pos_service_period: defaultPeriodDay,
        component_list_item: componentItemArr,
        bundled_option_series: bundleOptionItemArr,
      };
      console.log("editItemObj", editItemObj);
      resetAddItemHandler(editItemObj);
      dispatch(
        getMenuItemSubClass({ class_id: checkNull(menuItemObj?.menu_class_id) })
      );
    }
  }, [add_item_details?.menu_item]);

  useEffect(() => {
    if (item_ca_details?.data?.id) {
      componentItemChangeInputHandler(
        selectedComponentItemIndex,
        "other_category_id",
        item_ca_details?.data?.id
      );
    }
  }, [item_ca_details]);

  useEffect(() => {
    if (measurement_unit_details?.category?.id) {
      componentItemChangeInputHandler(
        selectedComponentItemIndex,
        "category_id",
        measurement_unit_details?.category?.id
      );
    }
  }, [measurement_unit_details]);

  useEffect(() => {
    const measureUnitPrice =
      add_item_details?.unit_price_detail?.measurement_price;
    if (checkNull(measureUnitPrice, false)) {
      if (
        addItemInputForm?.component_list_item?.[selectedComponentItemIndex]
          ?.measurement_choice_id == 1
      ) {
        componentItemChangeInputHandler(
          selectedComponentItemIndex,
          "unit_price",
          measureUnitPrice
        );
      }
    }
    const tempMeasureUnitPrice =
      add_item_details?.temp_unit_price_detail?.measurement_price;
    if (checkNull(tempMeasureUnitPrice, false)) {
      componentItemChangeInputHandler(
        selectedComponentItemIndex,
        "temp_unit_price",
        tempMeasureUnitPrice
      );
    }
    const multiplierVal = add_item_details?.multiplier_detail?.multiplier;
    if (checkNull(multiplierVal, false)) {
      componentItemChangeInputHandler(
        selectedComponentItemIndex,
        "temp_amount_used",
        multiplierVal
      );
    }
  }, [add_item_details]);

  /* Add Item */
  const addItemSchema = yup
    .object({
      id: yup.string().required(),
      menu_item_name: yup.string().required(),
      menu_item_type: yup.string().required(),
      menu_class_id: yup.string().required(),
      sub_class_id: yup.string().required(),
      is_production_item: yup.string().required(),
      storage_area_1_id: yup.string(),
      storage_area_2_id: yup.string(),
      pos_name: yup.string().required(),
      other_category_id: yup.string().required(),
      sub_category_id: yup.string().required(),
      description: yup.string().required(),
      allow_price_override: yup.string().required(),
      pos_color: yup.string().required(),
      kitchen_print_preference: yup.string().required(),
      scan_by: yup.string().when("menu_item_type", {
        is: "standard",
        then: yup.string().required(),
      }),
      sku_code: yup.string().when("menu_item_type", {
        is: "standard",
        then: yup.string().required(),
      }),
      allergy_tags: yup.array(),
      key_words: yup.array(),
      total_cost_per_menu_item: yup.number(),
      component_list_item: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          item_type: yup.string().required(),
          //recipe
          other_category_id: yup.string().when("item_type", {
            is: "recipe",
            then: yup.string().required(),
          }),
          recipe_id: yup.string().when("item_type", {
            is: "recipe",
            then: yup.string().required(),
          }),
          number_of_servings: yup.number().when("item_type", {
            is: "recipe",
            then: yup.number().positive().required(),
          }),
          //ingredient
          category_id: yup.string().when("item_type", {
            is: "ingredient",
            then: yup.string().required(),
          }),
          ingredient_id: yup.string().when("item_type", {
            is: "ingredient",
            then: yup.string().required(),
          }),
          measurement_choice_id: yup.string().when("item_type", {
            is: "ingredient",
            then: yup.string().required(),
          }),
          measurement_unit_id: yup.string().when("item_type", {
            is: "ingredient",
            then: yup.string().required(),
          }),
          unit_amount: yup.number().when("measurement_choice_id", {
            is: "1",
            then: yup.number().positive().required(),
          }),
          amount_used_unit_price: yup.string(), //not used yet
          temp_measurement_unit_id: yup.string().when("measurement_choice_id", {
            is: "2",
            then: yup.string().required(),
          }),
          temp_unit_price: yup.number().when("measurement_choice_id", {
            is: "2",
            then: yup.number().positive().required(),
          }),
          temp_amount_used: yup.number().when("measurement_choice_id", {
            is: "2",
            then: yup.number().positive().required(),
          }),
          unit_price: yup.number().when("item_type", {
            is: "ingredient",
            then: yup.number().positive().required(),
          }),
          amount_used: yup.number().when("measurement_choice_id", {
            is: "2",
            then: yup.number().positive().required(),
          }),

          item_component_cost: yup.number().positive().required(),
          proportion: yup.number(),
        })
      ),
      pos_service_period: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          period_start: yup.string().required(),
          period_end: yup.string().required(),
        })
      ),
      pos_applicable_period: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          is_checked: yup.boolean().required(),
          service_period_id: yup.string().required(),
          applicable_days: yup.array(),
        })
      ),
      bundled_option_series: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          sort: yup.string().required(),
          option_series: yup.string().required(),
          option_series_type: yup.string().when("option_series", {
            is: "new",
            then: yup.string().required(),
          }),
          option_series_name: yup.string().when("option_series", {
            is: "new",
            then: yup.string().required(),
          }),
          category_id: yup.string().required(),
          sub_category_id: yup.string().required(),
          bundle_menu_item_id: yup.array().min(1).required(),
          quantity: yup.number().positive().required(),
          action_price: yup.string().required(),
          unit_cost: yup.string().min(0).required(),
          amount: yup.number().min(0).required(),
          modifier_availability: yup.string().required(),
        })
      ),
    })
    .required();

  const initialAddItemForm = {
    id: id,
    menu_item_name: "",
    menu_item_type: "",
    menu_class_id: "",
    sub_class_id: "",
    is_production_item: "",
    storage_area_1_id: "",
    storage_area_2_id: "",
    pos_name: "",
    other_category_id: "",
    sub_category_id: "",
    description: "",
    allow_price_override: "",
    pos_color: "#3cc1c0",
    kitchen_print_preference: "1",
    scan_by: "Each",
    sku_code: "",
    allergy_tags: [],
    key_words: [],
    total_cost_per_menu_item: 0,
    component_list_item: [],
    bundled_option_series: [],
    pos_service_period: [],
    pos_applicable_period: [],
  };

  const [addItemInputForm, setAddItemInputForm] = useState(initialAddItemForm);

  const {
    register: addItemReg,
    formState: { errors: addItemErrors },
    handleSubmit: addItemSubmit,
    control: addItemControl,
    setValue: addItemSetValue,
    reset: addItemReset,
    trigger: addItemTrigger,
  } = useForm({
    resolver: yupResolver(addItemSchema),
    defaultValues: initialAddItemForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const changeAddItemInputHandler = (input, val) => {
    if (input == "storage_area_1_id" && val == "1") {
      setStorageAreaType(1);
      closeStorageAreaModal(true);
    } else if (input == "storage_area_2_id" && val == "1") {
      setStorageAreaType(2);
      closeStorageAreaModal(true);
    } else {
      if (input == "bundled_option_series") {
        if (checkArray(val)) {
          val = sortAllBundledOptionsPortion(val);
        }
        calculateAllBundledOptionsPortion(val);
      }
      addItemSetValue(input, val);
      setAddItemInputForm((prevState) => ({
        ...prevState,
        [input]: val,
      }));
      if (input == "menu_class_id") {
        changeAddItemInputHandler("sub_class_id", "");
        dispatch(getMenuItemSubClass({ class_id: val }));
      }

      if (input == "menu_item_type") {
        changeAddItemInputHandler("component_list_item", []);
        changeAddItemInputHandler("bundled_option_series", []);
      }
    }
  };

  const resetAddItemHandler = (resetVal = initialAddItemForm) => {
    setAddItemInputForm(resetVal);
    addItemReset(resetVal);
  };

  const addItemSubmitHandler = (data) => {
    const allergyTagsArr = checkArray(data?.allergy_tags)
      ? pluckArray(data?.allergy_tags, "value")
      : [];
    data.allergy_tags = checkArray(allergyTagsArr)
      ? allergyTagsArr.join(",")
      : "";
    const keyWordsArr = checkArray(data?.key_words) ? data?.key_words : [];
    data.key_words = checkArray(keyWordsArr) ? keyWordsArr.join(",") : "";
    const posAppPeriodArr = checkArray(data.pos_applicable_period)
      ? data.pos_applicable_period
      : [];
    data.pos_applicable_period = checkArray(posAppPeriodArr)
      ? posAppPeriodArr.map((periodItem) => {
          const applicableDaysArr = checkArray(periodItem?.applicable_days)
            ? pluckArray(periodItem?.applicable_days, "value")
            : [];
          return { ...periodItem, applicable_days: applicableDaysArr };
        })
      : [];
    const posServicePeriodArr = checkArray(data.pos_service_period)
      ? data.pos_service_period
      : [];
    data.pos_service_period = checkArray(posServicePeriodArr)
      ? posServicePeriodArr.map((servicePeriod) => {
          return {
            id: checkNull(servicePeriod?.id),
            period_start: changeDateFormat(
              servicePeriod?.period_start,
              "yyyy/MM/DD"
            ),
            period_end: changeDateFormat(
              servicePeriod?.period_end,
              "yyyy/MM/DD"
            ),
          };
        })
      : [];
    data.bundled_option_series =
      data?.menu_item_type == "bundled" &&
      checkArray(data.bundled_option_series)
        ? data.bundled_option_series.map((bundledOption) => ({
            id: checkNull(bundledOption?.id),
            sort: bundledOption?.sort,
            option_series_type: bundledOption?.option_series_type,
            series_total_allowed: bundledOption?.series_total_allowed,
            name: bundledOption?.option_series_name,
            isSelected: 1,
            bundled_menu_item: checkArray(bundledOption?.bundled_menu_item)
              ? bundledOption?.bundled_menu_item
              : [],
          }))
        : [];
    console.log("editData:", data);
    dispatch(saveAddMenuItem(data));
  };

  const deleteItemHandler = (backId) => {
    // dispatch(deleteFinanceReconcileSettings({ id: backId }));
  };

  const getErrorMsgForAddItem = (input) => {
    let res = null;
    const errorMsg = addItemErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={addItemErrors} name={input} />;
    }
    return res;
  };

  // Component List Item
  const initialComponentItemForm = {
    item_type: "",
    //recipe
    other_category_id: "",
    recipe_id: "",
    number_of_servings: 0,
    //ingredient
    category_id: "",
    ingredient_id: "",
    measurement_choice_id: "",
    measurement_unit_id: "",
    unit_amount: 0,
    amount_used_unit_price: "", //not used yet
    temp_measurement_unit_id: "",
    temp_unit_price: 0,
    temp_amount_used: 0,
    unit_price: 0,
    amount_used: 0,

    item_component_cost: 0,
    proportion: 0,
  };
  const [selectedComponentItemIndex, setSelectedComponentItemIndex] =
    useState(-1);
  const closeComponentItemModal = useCallback(
    (value, isSave = false) => {
      dispatch(changeMenuValue("componentItemModal", value));
      // initialComponentItemModalState();
      if (value) {
        addToComponentItem();
      } else if (!value && !isSave) {
        addToComponentItem(true);
      }
    },
    [componentItemModal, addItemInputForm, selectedComponentItemIndex]
  );

  const addToComponentItem = (isDelete = false) => {
    const newConvObj = deepCopy(addItemInputForm.component_list_item);
    const selectedComponentItem = newConvObj?.[selectedComponentItemIndex];
    if (isDelete) {
      newConvObj.pop();
      // if it is edited service period
      if (
        selectedComponentItem &&
        checkNull(selectedComponentItem?.id, false) &&
        add_item_details?.menu_item?.component_list_item &&
        add_item_details?.menu_item?.component_list_item.findIndex(
          (p) => p.id == selectedComponentItem?.id
        ) > -1
      ) {
        const newConvIndex =
          add_item_details?.menu_item?.component_list_item.findIndex(
            (p) => p.id == selectedComponentItem?.id
          );
        const newConvDummyObj =
          add_item_details?.menu_item?.component_list_item?.[newConvIndex];
        newConvObj.push({
          id: checkNull(newConvDummyObj?.id),
          amount_used: checkNull(newConvDummyObj?.amount_used_unit_price, 0),
          amount_used_unit_price: checkNull(
            newConvDummyObj?.amount_used_unit_price,
            ""
          ),
          category_id: checkNull(newConvDummyObj?.category_id, ""),
          ingredient_id: checkNull(newConvDummyObj?.ingredient_id, ""),
          item_component_cost: checkNull(
            newConvDummyObj?.item_component_cost,
            0
          ),
          item_type: checkNull(newConvDummyObj?.item_type, ""),
          measurement_choice_id: checkNull(
            newConvDummyObj?.measurement_choice_id,
            ""
          ),
          measurement_unit_id: checkNull(
            newConvDummyObj?.measurement_unit_id,
            ""
          ),
          number_of_servings: checkNull(newConvDummyObj?.number_of_servings, 0),
          other_category_id: checkNull(newConvDummyObj?.other_category_id, ""),
          proportion: checkNull(newConvDummyObj?.proportion, 0),
          recipe_id: checkNull(newConvDummyObj?.recipe_id, ""),
          temp_amount_used: checkNull(
            newConvDummyObj?.conversion_multiplier,
            0
          ),
          temp_measurement_unit_id: checkNull(
            newConvDummyObj?.temp_measurement_unit_id,
            ""
          ),
          temp_unit_price: checkNull(newConvDummyObj?.temp_unit_price, 0),
          unit_amount: checkNull(newConvDummyObj?.unit_amount, 0),
          unit_price: checkNull(newConvDummyObj?.amount_used_unit_price, 0),
        });
      }
      // if it is edited service period END
      setSelectedComponentItemIndex("");
    } else {
      newConvObj.push(initialComponentItemForm);
      const totalConvLength = addItemInputForm.component_list_item.length;
      setSelectedComponentItemIndex(totalConvLength);
    }
    changeAddItemInputHandler("component_list_item", newConvObj);
  };

  async function submitComponentItemModal() {
    const lastIndex = selectedComponentItemIndex;
    const result = await addItemTrigger([
      `component_list_item.${lastIndex}.item_type`,
      `component_list_item.${lastIndex}.other_category_id`,
      `component_list_item.${lastIndex}.recipe_id`,
      `component_list_item.${lastIndex}.number_of_servings`,
      `component_list_item.${lastIndex}.category_id`,
      `component_list_item.${lastIndex}.ingredient_id`,
      `component_list_item.${lastIndex}.measurement_choice_id`,
      `component_list_item.${lastIndex}.measurement_unit_id`,
      `component_list_item.${lastIndex}.unit_amount`,
      `component_list_item.${lastIndex}.amount_used_unit_price`,
      `component_list_item.${lastIndex}.temp_measurement_unit_id`,
      `component_list_item.${lastIndex}.temp_unit_price`,
      `component_list_item.${lastIndex}.temp_amount_used`,
      `component_list_item.${lastIndex}.unit_price`,
      `component_list_item.${lastIndex}.amount_used`,
      `component_list_item.${lastIndex}.item_component_cost`,
      `component_list_item.${lastIndex}.proportion`,
    ]);
    if (result) {
      calculateAllComponentPortion();
      closeComponentItemModal(false, true);
    }
  }

  const componentItemChangeInputHandler = (index, type, value) => {
    const checkCompItem = addItemInputForm?.component_list_item?.[index];
    if (checkNull(checkCompItem, false)) {
      if (type == "recipe_id" && checkNull(value, false)) {
        dispatch(getMenuItemCa(`/${value}`));
      }
      if (type == "ingredient_id" && checkNull(value, false)) {
        dispatch(getMenuMeasurementUnit(`/${value}`));
      }
      if (
        type == "measurement_unit_id" &&
        checkNull(value, false) &&
        checkNull(checkCompItem?.ingredient_id, false) &&
        checkNull(checkCompItem?.measurement_choice_id, false) &&
        checkCompItem?.measurement_choice_id == 1
      ) {
        dispatch(
          getMenuUnitPrice({
            mu_id: value,
            ing_id: checkCompItem?.ingredient_id,
          })
        );
      }
      if (
        type == "measurement_unit_id" &&
        checkNull(value, false) &&
        checkNull(checkCompItem?.temp_measurement_unit_id, false) &&
        checkNull(checkCompItem?.measurement_choice_id, false) &&
        checkCompItem?.measurement_choice_id == 2
      ) {
        dispatch(
          getMenuMultiUnit({
            from_id: checkCompItem?.temp_measurement_unit_id,
            to_id: value,
          })
        );
      }
      if (
        type == "temp_measurement_unit_id" &&
        checkNull(value, false) &&
        checkNull(checkCompItem?.ingredient_id, false)
      ) {
        dispatch(
          getMenuUnitPrice(
            {
              mu_id: value,
              ing_id: checkCompItem?.ingredient_id,
            },
            "temp_unit_price_detail"
          )
        );
      }
      if (
        type == "temp_amount_used" &&
        checkNull(value, false) &&
        checkNull(checkCompItem?.temp_unit_price, false)
      ) {
        componentItemChangeInputHandler(
          index,
          "unit_price",
          decimalValue(
            parseFloat(value) *
              parseFloat(checkNull(checkCompItem?.temp_unit_price, 0)),
            2,
            ""
          )
        );
      }
      if (type == "number_of_servings" && checkNull(value, false)) {
        componentItemChangeInputHandler(
          index,
          "item_component_cost",
          decimalValue(
            parseFloat(value) * parseFloat(item_ca_details?.rCpr ?? 0),
            2,
            ""
          )
        );
      }
      if (type == "unit_amount" && checkNull(value, false)) {
        componentItemChangeInputHandler(
          index,
          "item_component_cost",
          decimalValue(
            parseFloat(value) *
              parseFloat(checkNull(checkCompItem?.unit_price, 0)),
            2,
            ""
          )
        );
      }
      if (
        type == "amount_used" &&
        checkNull(value, false) &&
        checkNull(checkCompItem?.measurement_choice_id, false) &&
        checkCompItem?.measurement_choice_id == 2
      ) {
        componentItemChangeInputHandler(
          index,
          "item_component_cost",
          decimalValue(
            parseFloat(value) *
              parseFloat(checkNull(checkCompItem?.unit_price, 0)),
            2,
            ""
          )
        );
      }
      checkCompItem[type] = value;
      const addCompItem = deepCopy(addItemInputForm.component_list_item);
      addCompItem[index] = checkCompItem;
      changeAddItemInputHandler("component_list_item", addCompItem);
    }
  };

  const editCompItemHandler = (compIdx) => {
    const currentCompItem =
      addItemInputForm?.component_list_item?.[compIdx] ?? null;
    if (currentCompItem !== null) {
      if (checkNull(currentCompItem?.recipe_id, false)) {
        dispatch(getMenuItemCa(`/${currentCompItem?.recipe_id}`));
      }
      if (checkNull(currentCompItem?.ingredient_id, false)) {
        dispatch(getMenuMeasurementUnit(`/${currentCompItem?.ingredient_id}`));
      }
      if (
        checkNull(currentCompItem?.measurement_unit_id, false) &&
        checkNull(currentCompItem?.ingredient_id, false) &&
        checkNull(currentCompItem?.measurement_choice_id, false) &&
        currentCompItem?.measurement_choice_id == 1
      ) {
        dispatch(
          getMenuUnitPrice({
            mu_id: currentCompItem?.measurement_unit_id,
            ing_id: currentCompItem?.ingredient_id,
          })
        );
      }
      if (
        checkNull(currentCompItem?.measurement_unit_id, false) &&
        checkNull(currentCompItem?.temp_measurement_unit_id, false) &&
        checkNull(currentCompItem?.measurement_choice_id, false) &&
        currentCompItem?.measurement_choice_id == 2
      ) {
        dispatch(
          getMenuMultiUnit({
            from_id: currentCompItem?.temp_measurement_unit_id,
            to_id: currentCompItem?.measurement_unit_id,
          })
        );
      }
      if (
        checkNull(currentCompItem?.temp_measurement_unit_id, false) &&
        checkNull(currentCompItem?.ingredient_id, false)
      ) {
        dispatch(
          getMenuUnitPrice(
            {
              mu_id: currentCompItem?.temp_measurement_unit_id,
              ing_id: currentCompItem?.ingredient_id,
            },
            "temp_unit_price_detail"
          )
        );
      }
      setSelectedComponentItemIndex(compIdx);
      dispatch(changeMenuValue("componentItemModal", true));
    }
  };
  const deleteCompItemHandler = (compIdx) => {
    if (addItemInputForm?.component_list_item?.[compIdx]) {
      const addIngreConv = [...addItemInputForm.component_list_item];
      addIngreConv.splice(compIdx, 1);
      changeAddItemInputHandler("component_list_item", addIngreConv);
      calculateAllComponentPortion(addIngreConv);
    }
  };

  const getErrorMsgForComponentItem = (input) => {
    const index = selectedComponentItemIndex;
    let res = null;
    const errorMsg = addItemErrors?.component_list_item?.[index]?.[input];
    if (errorMsg && checkNull(errorMsg?.message)) {
      res = (
        <ErrorContainer
          message={errorMsg?.message}
          name={input}
          extraString={`component_list_item[${index}].${input}`}
          extraTo={`${input}`}
        />
      );
    }
    return res;
  };

  const calculateTotalCostPrice = (
    componentArr = addItemInputForm?.component_list_item
  ) => {
    let res = 0;
    if (checkArray(componentArr)) {
      res = componentArr.reduce(
        (sum, current) => sum + parseFloat(current.item_component_cost ?? 0),
        0
      );
    }
    return res;
  };

  const calculatePortion = (
    crpVal = 0,
    componentArr = addItemInputForm.component_list_item
  ) => {
    const totalCostPrice = calculateTotalCostPrice(componentArr);
    return (parseFloat(crpVal) / totalCostPrice) * 100;
  };

  const calculateAllComponentPortion = (
    componentArr = addItemInputForm.component_list_item
  ) => {
    if (checkArray(componentArr)) {
      let totalCost = 0;
      const newComponentArr = [...componentArr];
      newComponentArr.map((newRec) => {
        totalCost += parseFloat(newRec?.item_component_cost ?? 0);
        newRec.proportion = calculatePortion(
          newRec?.item_component_cost ?? 0,
          componentArr
        );
      });
      changeAddItemInputHandler("component_list_item", newComponentArr);
      changeAddItemInputHandler("total_cost_per_menu_item", totalCost);
    }
  };

  const getComponentList = () => {
    let res = null;
    if (checkArray(addItemInputForm?.component_list_item)) {
      res = addItemInputForm?.component_list_item.map((compItem, compIdx) => {
        return compItem?.item_type == "recipe" ? (
          <tr class="rowPar" id="rowPar0" count="0">
            <td class="">
              <span>{capitalizeFirstLetter(compItem?.item_type)}</span>
            </td>
            <td>
              {checkNull(
                add_item_details?.classes?.[compItem?.other_category_id]
              )}
            </td>
            <td>
              {checkNull(add_item_details?.recipes?.[compItem?.recipe_id])}
            </td>
            <td>{decimalValue(compItem?.number_of_servings, 2, "")} serving</td>
            <td>
              {decimalValue(
                compItem?.item_component_cost,
                2,
                getMerchantCurrencySymbol(user_details)
              )}
            </td>
            <td>
              <span class="edit_poc_span">
                {decimalValue(compItem?.proportion, 2, "")}%
              </span>
            </td>
            <td class="">
              <div class="event-time-edit p0">
                <a
                  class="editComponent"
                  onClick={() => editCompItemHandler(compIdx)}
                >
                  <i class="iconSprites edit-icon"></i>
                </a>
                <a
                  class="circle_icon red"
                  onClick={() => deleteCompItemHandler(compIdx)}
                >
                  <i class="iconSprites delete-icon"></i>
                </a>
              </div>
            </td>
          </tr>
        ) : (
          <tr class="rowPar" id="rowPar0" count="0">
            <td class="">
              <span>{capitalizeFirstLetter(compItem?.item_type)}</span>
            </td>
            <td>
              {checkNull(
                add_item_details?.category_list?.[compItem?.category_id]
              )}
            </td>
            <td>
              {checkNull(
                add_item_details?.ingredients?.[compItem?.ingredient_id]
              )}
            </td>
            <td>
              {decimalValue(compItem?.unit_amount, 2, "")}{" "}
              {checkNull(
                add_item_details?.servingUnits_only_name?.[
                  compItem?.measurement_unit_id
                ]
              )}
            </td>
            <td>
              {decimalValue(
                compItem?.item_component_cost,
                2,
                getMerchantCurrencySymbol(user_details)
              )}
            </td>
            <td>
              <span class="edit_poc_span">
                {decimalValue(compItem?.proportion, 2, "")}%
              </span>
            </td>
            <td class="">
              <div class="event-time-edit p0">
                <a
                  class="editComponent"
                  onClick={() => editCompItemHandler(compIdx)}
                >
                  <i class="iconSprites edit-icon"></i>
                </a>
                <a
                  class="circle_icon red"
                  onClick={() => deleteCompItemHandler(compIdx)}
                >
                  <i class="iconSprites delete-icon"></i>
                </a>
              </div>
            </td>
          </tr>
        );
      });
    } else if (checkArray(addItemInputForm?.bundled_option_series)) {
      if (checkArray(addItemInputForm?.bundled_option_series)) {
        res = addItemInputForm?.bundled_option_series.map(
          (option, optionInx) => {
            const parentDiv = (
              <tr>
                <td colspan="7" class="append_row p-0">
                  <table
                    width="100%"
                    cellspacing="0"
                    cellpadding="0"
                    class="checklist-table remove-space sex-coll parent-table option_Fixed_Items"
                    index={optionInx}
                    key={optionInx}
                  >
                    <tbody>
                      <tr class="parent">
                        <td style={{ width: "85.15%" }}>
                          <b>{option?.option_series_name}</b>
                          <br />
                          <span></span>
                        </td>
                        <td style={{ width: "190px" }}>
                          <div class="event-time-edit p0">
                            {/* <a class="editBundledMiParent arrow_hide" href="#_">
                            <i class="iconSprites edit-icon"></i>
                          </a> */}
                            <a
                              class="deleteBundledMiParent circle_icon red"
                              role="button"
                              onClick={() => deleteOptionItemHandler(optionInx)}
                            >
                              <i class="iconSprites delete-icon"></i>
                            </a>
                          </div>

                          <div class="event-time-edit up-down-btn-parent p0">
                            {optionInx !== 0 && (
                              <a
                                className="upParent"
                                onClick={() => {
                                  if (
                                    checkArray(
                                      addItemInputForm?.bundled_option_series
                                    )
                                  ) {
                                    changeAddItemInputHandler(
                                      "bundled_option_series",
                                      arrayMoveImmutable(
                                        addItemInputForm?.bundled_option_series,
                                        optionInx,
                                        optionInx - 1
                                      )
                                    );
                                  }
                                }}
                              >
                                {" "}
                                <i className="icon-arrow-up"></i>{" "}
                              </a>
                            )}
                            {optionInx !==
                              addItemInputForm?.bundled_option_series.length -
                                1 && (
                              <a
                                className="downParent"
                                onClick={() => {
                                  if (
                                    checkArray(
                                      addItemInputForm?.bundled_option_series
                                    )
                                  ) {
                                    changeAddItemInputHandler(
                                      "bundled_option_series",
                                      arrayMoveImmutable(
                                        addItemInputForm?.bundled_option_series,
                                        optionInx,
                                        optionInx + 1
                                      )
                                    );
                                  }
                                }}
                              >
                                {" "}
                                <i className="icon-arrow-down"></i>{" "}
                              </a>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr class="child-tr">
                        <td colspan="7" style={{ width: "100%", padding: 0 }}>
                          <table
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                            className="checklist-table remove-space sex-coll child-table m-0"
                          >
                            <tbody>
                              {checkArray(option?.bundled_menu_item) &&
                                option?.bundled_menu_item.map(
                                  (optionItem, optionItemIndx) => {
                                    const categoryId = parseInt(
                                      optionItem?.category_id
                                    );
                                    const categoryName =
                                      add_item_details?.otherCategories?.[
                                        categoryId
                                      ] ?? "";
                                    const subcategoryId = parseInt(
                                      optionItem?.sub_category_id
                                    );
                                    const subcategoryName =
                                      add_item_details?.sub_category?.[
                                        subcategoryId
                                      ] ?? "";
                                    return (
                                      <tr
                                        class="rowParBundle child"
                                        id={`rowParBundle${optionItemIndx}`}
                                        index={optionItemIndx}
                                        count={optionItemIndx + 1}
                                        key={optionItemIndx}
                                      >
                                        <td style={{ width: "174px" }}>
                                          <div class="child-name">
                                            {optionItem?.option_series_name}
                                            <br />
                                            <span></span>
                                          </div>
                                        </td>
                                        <td style={{ width: "140px" }}>
                                          {" "}
                                          {categoryName}{" "}
                                        </td>
                                        <td style={{ width: "182px" }}>
                                          {" "}
                                          {subcategoryName}{" "}
                                        </td>
                                        <td style={{ width: "235px" }}>
                                          {optionItem?.item_name ?? ""}
                                        </td>
                                        <td style={{ width: "130px" }}>
                                          {" "}
                                          {optionItem?.quantity ?? ""}
                                        </td>
                                        <td style={{ width: "250px" }}>
                                          {" "}
                                          {optionItem?.total_unit_cost ?? ""}
                                        </td>
                                        <td style={{ width: "190px" }}>
                                          {" "}
                                          <div class="event-time-edit p0">
                                            <a
                                              class="editBundledMiParent arrow_hide"
                                              role="button"
                                              onClick={() =>
                                                editOptionItemHandler(
                                                  optionInx,
                                                  optionItemIndx
                                                )
                                              }
                                            >
                                              <i class="iconSprites edit-icon"></i>
                                            </a>
                                            <a
                                              class="deleteBundledMiParent circle_icon red"
                                              role="button"
                                              onClick={() =>
                                                deleteOptionItemHandler(
                                                  optionInx,
                                                  optionItemIndx
                                                )
                                              }
                                            >
                                              <i class="iconSprites delete-icon"></i>
                                            </a>
                                          </div>
                                          <div class="event-time-edit up-down-btn-parent p0">
                                            {optionItemIndx !== 0 && (
                                              <a
                                                className="upParent"
                                                onClick={() => {
                                                  if (
                                                    checkArray(
                                                      option?.bundled_menu_item
                                                    )
                                                  ) {
                                                    bundledOptionsChangeInputHandler(
                                                      optionInx,
                                                      "bundled_menu_item",
                                                      arrayMoveImmutable(
                                                        option?.bundled_menu_item,
                                                        optionItemIndx,
                                                        optionItemIndx - 1
                                                      )
                                                    );
                                                  }
                                                }}
                                              >
                                                {" "}
                                                <i className="icon-arrow-up"></i>{" "}
                                              </a>
                                            )}
                                            {optionItemIndx !==
                                              option?.bundled_menu_item.length -
                                                1 && (
                                              <a
                                                className="downParent"
                                                onClick={() => {
                                                  if (
                                                    checkArray(
                                                      option?.bundled_menu_item
                                                    )
                                                  ) {
                                                    bundledOptionsChangeInputHandler(
                                                      optionInx,
                                                      "bundled_menu_item",
                                                      arrayMoveImmutable(
                                                        option?.bundled_menu_item,
                                                        optionItemIndx,
                                                        optionItemIndx + 1
                                                      )
                                                    );
                                                  }
                                                }}
                                              >
                                                {" "}
                                                <i className="icon-arrow-down"></i>{" "}
                                              </a>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            );
            return parentDiv;
          }
        );
      }
    }
    return res;
  };

  // Service Period List
  const initialServiceItemForm = {
    period_start: "",
    period_end: "",
  };
  const [selectedServiceItemIndex, setSelectedServiceItemIndex] = useState(-1);
  const closeServiceItemModal = useCallback(
    (value, isSave = false) => {
      dispatch(changeMenuValue("serviceItemModal", value));
      // initialServiceItemModalState();
      if (value) {
        addToServiceItem();
      } else if (!value && !isSave) {
        addToServiceItem(true);
      }
    },
    [serviceItemModal, addItemInputForm, selectedServiceItemIndex]
  );

  const addToServiceItem = (isDelete = false) => {
    const newConvObj = deepCopy(addItemInputForm.pos_service_period);
    const selectedSerPeriod = newConvObj?.[selectedServiceItemIndex];
    if (isDelete) {
      newConvObj.pop();
      // if it is edited service period
      if (
        selectedSerPeriod &&
        checkNull(selectedSerPeriod?.id, false) &&
        add_item_details?.menu_item?.pos_service_period &&
        add_item_details?.menu_item?.pos_service_period.findIndex(
          (p) => p.id == selectedSerPeriod?.id
        ) > -1
      ) {
        const newConvIndex =
          add_item_details?.menu_item?.pos_service_period.findIndex(
            (p) => p.id == selectedSerPeriod?.id
          );
        const newConvDummyObj =
          add_item_details?.menu_item?.pos_service_period?.[newConvIndex];
        newConvObj.push({
          id: newConvDummyObj?.id ?? "",
          period_start: checkNull(newConvDummyObj?.period_start, false)
            ? moment(newConvDummyObj?.period_start).toDate()
            : "",
          period_end: checkNull(newConvDummyObj?.period_end, false)
            ? moment(newConvDummyObj?.period_end).toDate()
            : "",
        });
      }
      // if it is edited service period END

      setSelectedServiceItemIndex("");
    } else {
      newConvObj.push(initialServiceItemForm);
      const totalConvLength = addItemInputForm.pos_service_period.length;
      setSelectedServiceItemIndex(totalConvLength);
    }
    changeAddItemInputHandler("pos_service_period", newConvObj);
  };

  async function submitServiceItemModal() {
    const lastIndex = selectedServiceItemIndex;
    const result = await addItemTrigger([
      `pos_service_period.${lastIndex}.period_start`,
      `pos_service_period.${lastIndex}.period_end`,
    ]);
    if (result) {
      closeServiceItemModal(false, true);
    }
  }

  const serviceItemChangeInputHandler = (index, type, value) => {
    const checkServiceItem = addItemInputForm?.pos_service_period?.[index];
    if (checkNull(checkServiceItem, false)) {
      if (type == "period_start") {
        checkServiceItem["period_end"] = "";
      }
      checkServiceItem[type] = value;
      const addServiceItem = deepCopy(addItemInputForm.pos_service_period);
      addServiceItem[index] = checkServiceItem;
      changeAddItemInputHandler("pos_service_period", addServiceItem);
    }
  };

  const editServiceItemHandler = (compIdx) => {
    const currentServiceItem =
      addItemInputForm?.pos_service_period?.[compIdx] ?? null;
    if (currentServiceItem !== null) {
      setSelectedServiceItemIndex(compIdx);
      dispatch(changeMenuValue("serviceItemModal", true));
    }
  };
  const deleteServiceItemHandler = (compIdx) => {
    if (addItemInputForm?.pos_service_period?.[compIdx]) {
      const addIngreConv = [...addItemInputForm.pos_service_period];
      addIngreConv.splice(compIdx, 1);
      changeAddItemInputHandler("pos_service_period", addIngreConv);
    }
  };

  const getErrorMsgForServiceItem = (input) => {
    const index = selectedServiceItemIndex;
    let res = null;
    const errorMsg = addItemErrors?.pos_service_period?.[index]?.[input];
    if (errorMsg && checkNull(errorMsg?.message)) {
      res = (
        <ErrorContainer
          message={errorMsg?.message}
          name={input}
          extraString={`pos_service_period[${index}].${input}`}
          extraTo={`${input}`}
        />
      );
    }
    return res;
  };

  const getServiceItemList = () => {
    let res = null;
    if (checkArray(addItemInputForm?.pos_service_period)) {
      res = addItemInputForm?.pos_service_period.map(
        (serviceItem, serviceIdx) => {
          return (
            <>
              <tr
                class="rowSP"
                id={`rowSP${serviceIdx + 1}`}
                count={`${serviceIdx + 1}`}
              >
                <td>
                  {changeDateFormat(serviceItem?.period_start, "DD/MM/yyyy")}
                </td>
                <td>
                  {changeDateFormat(serviceItem?.period_end, "DD/MM/yyyy")}
                </td>
                <td class="">
                  <div class="event-time-edit p0">
                    <a
                      class="editServicePeriod"
                      onClick={() => editServiceItemHandler(serviceIdx)}
                    >
                      <i class="iconSprites edit-icon"></i>
                    </a>
                    <a
                      class="deleteServicePeriod circle_icon red"
                      onClick={() => deleteServiceItemHandler(serviceIdx)}
                    >
                      <i class="iconSprites delete-icon"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </>
          );
        }
      );
    }
    return res;
  };

  // Applicable Period
  const periodItemChangeInputHandler = (index, type, value) => {
    const checkPeriodItem = addItemInputForm?.pos_applicable_period?.[index];
    if (checkNull(checkPeriodItem, false)) {
      checkPeriodItem[type] = value;
      const addPeriodItem = deepCopy(addItemInputForm.pos_applicable_period);
      addPeriodItem[index] = checkPeriodItem;
      changeAddItemInputHandler("pos_applicable_period", addPeriodItem);
    }
  };

  // Item Price List

  useEffect(() => {
    if (edit_pricings_details !== null) {
      const editDetails = {
        id: `${edit_pricings_details?.id}`,
        sales_type_id: edit_pricings_details?.sales_type_id ?? "",
        menu_price: edit_pricings_details?.menu_price
          ? parseFloat(edit_pricings_details?.menu_price)
          : 0,
        profit_margin: edit_pricings_details?.profit_margin
          ? parseFloat(edit_pricings_details?.profit_margin)
          : 0,
        sales_tax: edit_pricings_details?.sales_tax
          ? parseFloat(edit_pricings_details?.sales_tax)
          : 0,
        service_charge: edit_pricings_details?.service_charge
          ? parseFloat(edit_pricings_details?.service_charge)
          : 0,
        button_color: checkNull(edit_pricings_details?.button_color),
      };
      initialPriceItemModalState(editDetails);
    }
  }, [edit_pricings_details]);

  // useEffect(() => {
  //   checkDublicateFixedItems()
  // }, [addItemInputForm?.bundled_option_series]);

  const checkDublicateFixedItems = (bundled_option_series) => {
    if (
      checkArray(bundled_option_series) &&
      bundled_option_series.filter(
        (p) =>
          p.option_series == "Fixed Items" && checkArray(p.bundled_menu_item)
      ).length > 1
    ) {
      const copyBundleOptions = deepCopy(bundled_option_series);
      const withFixed = copyBundleOptions.filter(
        (p) =>
          p.option_series == "Fixed Items" && checkArray(p.bundled_menu_item)
      );
      const withOutFixed = copyBundleOptions.filter(
        (p) =>
          !(p.option_series == "Fixed Items" && checkArray(p.bundled_menu_item))
      );
      let newFixedArr = [];
      let newFixedObj = {};
      withFixed.map((item, itemIdx) => {
        if (itemIdx == 0) {
          newFixedObj = deepCopy(item);
        }
        newFixedArr = [...newFixedArr, ...item.bundled_menu_item];
      });
      if (checkArray(newFixedArr)) {
        //update sort value in new array
        newFixedArr = newFixedArr.map((fixedItm, fixedItmInd) => ({
          ...fixedItm,
          sort: fixedItmInd + 1,
        }));
      }
      if (newFixedArr && newFixedArr.length > 0) {
        withOutFixed.push({ ...newFixedObj, bundled_menu_item: newFixedArr }); //push fixed merge object to array
      }
      return withOutFixed;
    }
    if (checkArray(bundled_option_series?.bundled_menu_item)) {
      //update sort value in bundled_menu_item
      bundled_option_series.bundled_menu_item =
        bundled_option_series?.bundled_menu_item.map(
          (bundledItm, bundledItmInd) => ({
            ...bundledItm,
            sort: bundledItmInd + 1,
          })
        );
    }
    return bundled_option_series;
  };

  const initialPriceItemForm = {
    id: "",
    sales_type_id: "",
    menu_price: 0,
    profit_margin: 100,
    sales_tax: 0,
    service_charge: 0,
    button_color: "#3cc1c0",
  };

  const priceItemSchema = yup
    .object({
      id: yup.string(),
      sales_type_id: yup.string().required(),
      menu_price: yup.number().positive(),
      profit_margin: yup.number().positive().max(100),
      sales_tax: yup.number().min(0).max(1),
      service_charge: yup.number().min(0).max(1),
      button_color: yup.string().required(),
    })
    .required();

  const {
    register: priceItemReg,
    formState: { errors: priceItemErrors },
    handleSubmit: priceItemSubmit,
    control: priceItemControl,
    setValue: priceItemSetValue,
    reset: priceItemReset,
    trigger: priceItemTrigger,
  } = useForm({
    resolver: yupResolver(priceItemSchema),
    defaultValues: initialPriceItemForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const [priceItemInputForm, setPriceItemInputForm] =
    useState(initialPriceItemForm);

  const initialPriceItemModalState = (resetVal = initialPriceItemForm) => {
    priceItemReset(resetVal);
    setPriceItemInputForm(resetVal);
  };

  const closePriceItemModal = useCallback(
    (value) => {
      dispatch(changeMenuValue("priceItemModal", value));
      dispatch(changeMenuValue("edit_pricings_details", null));
      initialPriceItemModalState();
    },
    [priceItemModal, priceItemInputForm]
  );

  const submitPriceItemModal = (data) => {
    if (data) {
      // data.sales_type_id = data.sales_type_id.map((salesId) => salesId?.value);
      // dispatch(saveAddMenuPricings(data));
      data.menu_item_id = id;
      dispatch(saveEditMenuPricings(data));
    }
  };

  const priceItemChangeInputHandler = (input, val) => {
    priceItemSetValue(input, val);
    setPriceItemInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };

  const editPriceItemHandler = (priceItemId) => {
    dispatch(getEditMenuEditPricings(`/${id}/${priceItemId}`));
  };

  const deletePriceItemHandler = (priceItemId) => {
    dispatch(deleteEditMenuPricings({ id: priceItemId, menu_item_id: id }));
  };

  const getErrorMsgForPriceItem = (input) => {
    let res = null;
    const errorMsg = priceItemErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={priceItemErrors} name={input} />;
    }
    return res;
  };

  const getPriceItemList = () => {
    let res = null;
    if (checkArray(saved_pricings_details)) {
      res = saved_pricings_details.map((priceItem) => {
        let salesTypeName = priceItem?.salesType?.type_name ?? "";
        return (
          <tr>
            <td>
              <div class="sales_type_name">
                <strong> {salesTypeName} </strong>
              </div>
              <span class="span_menu_price">
                {decimalValue(priceItem?.menu_price, 4)}{" "}
                <i>({priceItem?.profit_margin}% Margin)</i>
              </span>
            </td>
            <td>
              <div class="event-time-edit p0">
                <a
                  class="editPricing"
                  onClick={() => editPriceItemHandler(priceItem?.id)}
                >
                  <i class="iconSprites edit-icon"></i>
                </a>
                <a
                  class="deletePricing circle_icon red"
                  onClick={() => deletePriceItemHandler(priceItem?.id)}
                >
                  <i class="iconSprites delete-icon"></i>
                </a>
              </div>
            </td>
          </tr>
        );
      });
    }
    return res;
  };

  // Add bundled option series
  useEffect(() => {
    const currentSelectedItem =
      addItemInputForm?.bundled_option_series?.[selectedBundledOptionsIndex];
    if (
      checkArray(cost_per_item) &&
      currentSelectedItem &&
      checkArray(currentSelectedItem?.bundle_menu_item_id)
    ) {
      const copyMenuIds = deepCopy(currentSelectedItem.bundle_menu_item_id);
      const newMenuIds = copyMenuIds.map((copyItem) => {
        const checkAmountInx = cost_per_item.findIndex(
          (p) => p.id == copyItem.value
        );
        const itemQuantity = parseFloat(currentSelectedItem?.quantity ?? 0);
        const menuAmount =
          checkAmountInx > -1
            ? parseFloat(cost_per_item?.[checkAmountInx]?.amount ?? 0)
            : 0;
        return {
          ...copyItem,
          amount: menuAmount,
          total_amount: itemQuantity * menuAmount,
        };
      });
      bundledOptionsChangeInputHandler(
        selectedBundledOptionsIndex,
        "bundle_menu_item_id",
        newMenuIds
      );
    }
  }, [cost_per_item]);

  const initialBundledOptionsForm = {
    sort: "",
    option_series: "",
    option_series_type: "",
    option_series_name: "",
    category_id: "",
    sub_category_id: "",
    bundle_menu_item_id: [],
    quantity: 0,
    action_price: "",
    unit_cost: 0,
    amount: 0,
    modifier_availability: 0,
    bundled_menu_item: [],
  };
  const initialBundledMenuItem = {
    sort: 1,
    option_series_name: "",
    category_id: "",
    sub_category_id: "",
    bundle_menu_item_id: "",
    quantity: 0,
    action_price: "add",
    unit_cost: 0,
    amount: 0,
    modifier_availability: "",
  };
  const [selectedBundledOptionsIndex, setSelectedBundledOptionsIndex] =
    useState(-1);
  const [editBundledOption, setEditBundledOption] = useState(null);
  const [editBundledOptionInx, setEditBundledOptionInx] = useState(null);
  const closeBundledOptionsModal = useCallback(
    (value, isSave = false) => {
      setEditBundledOption(null);
      setEditBundledOptionInx(null);
      dispatch(changeMenuValue("bundledOptionsModal", value));
      // initialBundledOptionsModalState();
      if (value) {
        addToBundledOptions();
      } else if (!value && !isSave) {
        addToBundledOptions(true);
      }
    },
    [
      bundledOptionsModal,
      addItemInputForm,
      selectedBundledOptionsIndex,
      editBundledOption,
      editBundledOptionInx,
    ]
  );

  const addToBundledOptions = (isDelete = false) => {
    const newConvObj = deepCopy(addItemInputForm.bundled_option_series);
    if (isDelete) {
      newConvObj.pop();
      setSelectedBundledOptionsIndex("");
    } else {
      const totalConvLength = addItemInputForm.bundled_option_series.length;
      newConvObj.push({
        ...initialBundledOptionsForm,
        sort: totalConvLength + 1,
      });
      setSelectedBundledOptionsIndex(totalConvLength);
    }
    changeAddItemInputHandler("bundled_option_series", newConvObj);
  };

  const sortAllBundledOptionsPortion = (
    bundledOptionsArr = addItemInputForm.bundled_option_series
  ) => {
    if (checkArray(bundledOptionsArr)) {
      const newBundledOptionsArr = [...bundledOptionsArr];
      bundledOptionsArr = newBundledOptionsArr.map((newRec, newRecInx) => {
        return { ...newRec, sort: newRecInx + 1 };
      });
    }
    return bundledOptionsArr;
  };

  const calculateAllBundledOptionsPortion = (
    bundledOptionsArr = addItemInputForm.bundled_option_series
  ) => {
    if (checkArray(bundledOptionsArr)) {
      let totalCost = 0;
      const newBundledOptionsArr = [...bundledOptionsArr];
      newBundledOptionsArr.map((newRec) => {
        if (checkArray(newRec?.bundled_menu_item)) {
          newRec?.bundled_menu_item.map((bunItem) => {
            totalCost += parseFloat(bunItem?.total_unit_cost ?? 0);
          });
        }
      });
      changeAddItemInputHandler("total_cost_per_menu_item", totalCost);
    }
  };

  async function submitBundledOptionsModal() {
    const lastIndex = selectedBundledOptionsIndex;
    const result = await addItemTrigger([
      `bundled_option_series.${lastIndex}.sort`,
      `bundled_option_series.${lastIndex}.option_series`,
      `bundled_option_series.${lastIndex}.option_series_type`,
      `bundled_option_series.${lastIndex}.option_series_name`,
      `bundled_option_series.${lastIndex}.category_id`,
      `bundled_option_series.${lastIndex}.sub_category_id`,
      `bundled_option_series.${lastIndex}.bundle_menu_item_id`,
      `bundled_option_series.${lastIndex}.quantity`,
      `bundled_option_series.${lastIndex}.action_price`,
      `bundled_option_series.${lastIndex}.unit_cost`,
      `bundled_option_series.${lastIndex}.amount`,
      `bundled_option_series.${lastIndex}.modifier_availability`,
    ]);
    if (result) {
      const selectedBundle =
        addItemInputForm?.bundled_option_series?.[lastIndex];
      const bundleMenuIds = selectedBundle?.bundle_menu_item_id;
      const bundledMenuItems = checkArray(bundleMenuIds)
        ? bundleMenuIds.map((bunItem, bunItemIdx) => {
            return {
              ...initialBundledMenuItem,
              sort: bunItemIdx + 1,
              offlineId: getRandomString(),
              option_series_name: selectedBundle?.option_series_name,
              category_id: selectedBundle?.category_id,
              sub_category_id: selectedBundle?.sub_category_id,
              bundle_menu_item_id: bunItem?.value,
              quantity: selectedBundle?.quantity,
              action_price: selectedBundle?.action_price,
              unit_cost: bunItem?.amount,
              total_unit_cost: bunItem?.total_amount,
              item_name: bunItem?.label,
              amount: selectedBundle?.amount,
              modifier_availability: selectedBundle?.modifier_availability,
            };
          })
        : [];

      if (checkNull(editBundledOption, false)) {
        // create new if options are change
        const selectedBundledMenuItems = bundledMenuItems?.[0];
        if (
          editBundledOption?.bundle_menu_item_id !==
            selectedBundledMenuItems?.bundle_menu_item_id ||
          editBundledOption?.category_id !==
            selectedBundledMenuItems?.category_id ||
          editBundledOption?.sub_category_id !==
            selectedBundledMenuItems?.sub_category_id ||
          editBundledOption?.bundle_menu_item_id !==
            selectedBundledMenuItems?.bundle_menu_item_id
        ) {
          bundledOptionsChangeInputHandler(
            lastIndex,
            "bundled_menu_item",
            bundledMenuItems
          );
          deleteOptionItemHandler(
            editBundledOptionInx?.optionIdx,
            editBundledOptionInx?.optionItemIndx
          );
          closeBundledOptionsModal(false, true);
        } else {
          const newEditbundle =
            addItemInputForm?.bundled_option_series?.[
              editBundledOptionInx?.optionIdx
            ];
          const newEditbundleItems = [...newEditbundle.bundled_menu_item];
          newEditbundleItems[editBundledOptionInx?.optionItemIndx] =
            selectedBundledMenuItems;
          if (newEditbundle) {
            bundledOptionsChangeInputHandler(
              editBundledOptionInx?.optionIdx,
              "bundled_menu_item",
              newEditbundleItems
            );
          }
          closeBundledOptionsModal(false);
        }
        // calculateAllComponentPortion();
      } else {
        bundledOptionsChangeInputHandler(
          lastIndex,
          "bundled_menu_item",
          bundledMenuItems
        );
        // calculateAllComponentPortion();
        closeBundledOptionsModal(false, true);
      }
    }
  }

  const bundledOptionsChangeInputHandler = (
    index,
    type,
    value,
    sortBundleItems = true
  ) => {
    const checkOptionItem = addItemInputForm?.bundled_option_series?.[index];
    if (checkNull(checkOptionItem, false)) {
      if (
        type == "option_series" &&
        checkNull(value, false) &&
        value == "Fixed Items"
      ) {
        bundledOptionsChangeInputHandler(
          index,
          "option_series_name",
          "Fixed Items"
        );
      } else if (
        type == "option_series" &&
        (value == "Fixed Items" || value == "")
      ) {
        bundledOptionsChangeInputHandler(index, "option_series_name", "");
      }
      if (type == "category_id" && checkNull(value, false)) {
        dispatch(getMenuItemSubCategory({ category_id: value }));
      }
      if (type == "sub_category_id" && checkNull(value, false)) {
        dispatch(getMenusList({ category_id: value }));
      }
      checkOptionItem[type] = value;
      let addOptionItem = deepCopy(addItemInputForm.bundled_option_series);
      addOptionItem[index] = checkOptionItem;
      if (type == "bundled_menu_item" && sortBundleItems) {
        addOptionItem = checkDublicateFixedItems(addOptionItem);
      }
      changeAddItemInputHandler("bundled_option_series", addOptionItem);
    }
  };

  const editOptionItemHandler = (optionIdx, optionItemIndx) => {
    const currentOption =
      addItemInputForm?.bundled_option_series?.[optionIdx] ?? null;
    const currentOptionItem =
      addItemInputForm?.bundled_option_series?.[optionIdx]?.bundled_menu_item?.[
        optionItemIndx
      ] ?? null;
    if (checkNull(currentOptionItem, false)) {
      const newOptionObj = deepCopy(addItemInputForm.bundled_option_series);
      if (checkNull(currentOptionItem?.category_id, false)) {
        dispatch(
          getMenuItemSubCategory({
            category_id: currentOptionItem?.category_id,
          })
        );
      }
      if (checkNull(currentOptionItem?.sub_category_id, false)) {
        dispatch(
          getMenusList({ category_id: currentOptionItem?.sub_category_id })
        );
      }
      setEditBundledOption(currentOptionItem);
      setEditBundledOptionInx({ optionIdx, optionItemIndx });
      const totalConvLength = addItemInputForm.bundled_option_series.length;
      newOptionObj.push({
        ...currentOption,
        bundle_menu_item_id: [
          {
            amount: currentOptionItem?.unit_cost,
            label: currentOptionItem?.item_name,
            total_amount: currentOptionItem?.total_unit_cost,
            value: currentOptionItem?.bundle_menu_item_id,
          },
        ],
        bundled_menu_item: [],
        sort: totalConvLength + 1,
        option_series_name: currentOptionItem?.option_series_name,
        category_id: currentOptionItem?.category_id,
        sub_category_id: currentOptionItem?.sub_category_id,
        quantity: currentOptionItem?.quantity,
        action_price: currentOptionItem?.action_price,
        amount: currentOptionItem?.amount,
        modifier_availability: currentOptionItem?.modifier_availability,
      });
      changeAddItemInputHandler("bundled_option_series", newOptionObj);
      setSelectedBundledOptionsIndex(totalConvLength);
      dispatch(changeMenuValue("bundledOptionsModal", true));
    }
  };
  const deleteOptionItemHandler = (optionIdx, optionItemIndx = "") => {
    if (addItemInputForm?.bundled_option_series?.[optionIdx]) {
      const bundleOptionItems = deepCopy(
        addItemInputForm.bundled_option_series
      );
      if (
        checkNull(optionItemIndx, false) &&
        checkArray(bundleOptionItems?.[optionIdx]?.bundled_menu_item)
      ) {
        bundleOptionItems?.[optionIdx]?.bundled_menu_item.splice(
          optionItemIndx,
          1
        );
        if (!checkArray(bundleOptionItems?.[optionIdx]?.bundled_menu_item)) {
          bundleOptionItems.splice(optionIdx, 1);
        }
      } else {
        bundleOptionItems.splice(optionIdx, 1);
      }
      changeAddItemInputHandler("bundled_option_series", bundleOptionItems);
      // calculateAllComponentPortion(addIngreConv);
    }
  };

  const getErrorMsgForBundledOptions = (input) => {
    const index = selectedBundledOptionsIndex;
    let res = null;
    const errorMsg = addItemErrors?.bundled_option_series?.[index]?.[input];
    if (errorMsg && checkNull(errorMsg?.message)) {
      res = (
        <ErrorContainer
          message={errorMsg?.message}
          name={input}
          extraString={`bundled_option_series[${index}].${input}`}
          extraTo={`${input}`}
        />
      );
    }
    return res;
  };

  const getCostPerItemPrices = () => {
    const checkOptionItem =
      addItemInputForm?.bundled_option_series?.[selectedBundledOptionsIndex];
    if (checkOptionItem && checkArray(checkOptionItem?.bundle_menu_item_id)) {
      dispatch(
        getCostPerItem({
          menu_item_id: checkOptionItem?.bundle_menu_item_id.map(
            (menuId) => menuId.value
          ),
        })
      );
    }
  };

  /* Storage Area Popups */
  useEffect(() => {
    setStorageAreaInput("");
    setStorageAreaType(1);
  }, [storageAreaModalModal]);
  useEffect(() => {
    if (checkNull(add_storage_new_id, false)) {
      changeAddItemInputHandler(
        storageAreaType == 1 ? "storage_area_1_id" : "storage_area_2_id",
        `${add_storage_new_id}`
      );
    }
  }, [add_storage_new_id]);

  const [storageAreaInput, setStorageAreaInput] = useState("");
  const [storageAreaType, setStorageAreaType] = useState(1);

  const closeStorageAreaModal = useCallback(
    (value) => {
      dispatch(changeMenuValue("storageAreaModalModal", value));
    },
    [storageAreaModalModal]
  );

  const submitStorageAreaModal = () => {
    dispatch(
      saveStorageAreaDetails({
        type: storageAreaType,
        name: storageAreaInput,
        actionFrom: "menu_item",
      })
    );
  };

  return (
    <>
      <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
        <form onSubmit={addItemSubmit(addItemSubmitHandler)}>
          <div className="container px-0">
            <div className="row d-flex">
              <div className="col-md-12 modify">
                <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100 mb-0">Menu Item Details</h4>
                  <p classname="mb-5">
                    Enter all available details about your Menu Item available
                    for sale.
                  </p>
                  <div className="d-flex calc-height w-100 flex-wrap">
                    <div className="settings-left-content fixed-pos col-3">
                      <ul className="settingMenus">
                        <li className="active">
                          <a href="#MenuItemInfo">
                            Menu Item <br /> Info
                          </a>
                        </li>
                        <li className="">
                          <a href="#posSetting">POS Settings</a>
                        </li>
                        <li className="">
                          <a href="#tags">Tags</a>
                        </li>
                      </ul>
                    </div>

                    <div className="settings-right-content scrolling col-9">
                      <div className="date-sec-scroll">
                        <div
                          id="MenuItemInfo"
                          className="row-fluid scroll-change full_div"
                          day_time="Address"
                        >
                          <div className="form-secs">
                            <h4> Menu Item Info </h4>
                            <ul class="ingredient-info edit-shift">
                              <GroupInput
                                label={"Menu Item Name"}
                                name="menu_item_name"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "menu_item_name",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.menu_item_name}
                                errorMsg={getErrorMsgForAddItem(
                                  "menu_item_name"
                                )}
                              />
                              <GroupSelect
                                label={"Menu Item Type"}
                                name="menu_item_type"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "menu_item_type",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.menu_item_type}
                                options={createSelectOptions(
                                  add_item_details?.menu_item_type
                                )}
                                errorMsg={getErrorMsgForAddItem(
                                  "menu_item_type"
                                )}
                              />
                              <GroupSelect
                                label={"Menu Item Class"}
                                name="menu_class_id"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "menu_class_id",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.menu_class_id}
                                options={createSelectOptions(
                                  add_item_details?.classes
                                )}
                                errorMsg={getErrorMsgForAddItem(
                                  "menu_class_id"
                                )}
                              />
                              <GroupSelect
                                label={"Menu Item Sub-Class"}
                                name="sub_class_id"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "sub_class_id",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.sub_class_id}
                                options={createSelectOptions(
                                  item_subclass_detail
                                )}
                                errorMsg={getErrorMsgForAddItem("sub_class_id")}
                              />
                              <GroupSelect
                                label={"Is Production Item"}
                                name="is_production_item"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "is_production_item",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.is_production_item}
                                options={createYesNoSelectOptions()}
                                errorMsg={getErrorMsgForAddItem(
                                  "is_production_item"
                                )}
                              />
                              <GroupSelect
                                label={"Storage Area #1"}
                                name="storage_area_1_id"
                                className="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "storage_area_1_id",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.storage_area_1_id}
                                options={createSelectOptions(
                                  add_item_details?.storage_area_1s
                                )}
                                errorMsg={getErrorMsgForAddItem(
                                  "storage_area_1_id"
                                )}
                              />
                              <GroupSelect
                                label={"Storage Area #2"}
                                name="storage_area_2_id"
                                className="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "storage_area_2_id",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.storage_area_2_id}
                                options={createSelectOptions(
                                  add_item_details?.storage_area_2s
                                )}
                                errorMsg={getErrorMsgForAddItem(
                                  "storage_area_2_id"
                                )}
                              />
                            </ul>
                          </div>
                        </div>

                        <div
                          id="posSetting"
                          className="row-fluid scroll-change full_div"
                          day_time="AccDetail"
                        >
                          <div className="form-secs">
                            <h4> POS Settings </h4>

                            <ul class="ingredient-info edit-shift d-flex">
                              <GroupInput
                                label={"POS Name (25 Char. Max.)"}
                                name="pos_name"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "pos_name",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.pos_name}
                                errorMsg={getErrorMsgForAddItem("pos_name")}
                              />
                              <GroupSelect
                                label={"POS Category"}
                                name="other_category_id"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "other_category_id",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.other_category_id}
                                options={createSelectOptions(
                                  add_item_details?.otherCategories
                                )}
                                errorMsg={getErrorMsgForAddItem(
                                  "other_category_id"
                                )}
                              />
                              <GroupSelect
                                label={"POS Sub-Category"}
                                name="sub_category_id"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "sub_category_id",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.sub_category_id}
                                options={createSelectOptions(
                                  add_item_details?.sub_category
                                )}
                                errorMsg={getErrorMsgForAddItem(
                                  "sub_category_id"
                                )}
                              />
                              <GroupTextArea
                                label={"POS Description"}
                                name="description"
                                className="required"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "description",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.description}
                                errorMsg={getErrorMsgForAddItem("description")}
                              />
                              <GroupSelect
                                label={"Allow Price Overrides in POS"}
                                name="allow_price_override"
                                className="required"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "allow_price_override",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.allow_price_override}
                                options={createSelectOptions(
                                  add_item_details?.allow_price_override
                                )}
                                errorMsg={getErrorMsgForAddItem(
                                  "allow_price_override"
                                )}
                              />
                              <GroupColorInput
                                label={"Button Color"}
                                name="pos_color"
                                labelClass="required"
                                divClass="input-group col-md-7"
                                onChange={(e) =>
                                  changeAddItemInputHandler(
                                    "pos_color",
                                    e?.target?.value
                                  )
                                }
                                value={addItemInputForm?.pos_color}
                                errorMsg={getErrorMsgForAddItem("pos_color")}
                              />
                              {addItemInputForm?.menu_item_type ==
                                "bundled" && (
                                <>
                                  <GroupSelect
                                    label={"Kitchen Print Preference"}
                                    name="kitchen_print_preference"
                                    className="required"
                                    divClass="input-group col-md-7"
                                    onChange={(e) =>
                                      changeAddItemInputHandler(
                                        "kitchen_print_preference",
                                        e?.target?.value
                                      )
                                    }
                                    value={
                                      addItemInputForm?.kitchen_print_preference
                                    }
                                    options={createSelectOptions(
                                      add_item_details?.StatemenuReduceradd_item_detailskitchen_print_preferences
                                    )}
                                    errorMsg={getErrorMsgForAddItem(
                                      "kitchen_print_preference"
                                    )}
                                  />
                                  <GroupSelect
                                    label={"Hide Fixed Items"}
                                    name="hide_fixed_items"
                                    className="required"
                                    labelClass="required"
                                    divClass="input-group col-md-7"
                                    onChange={(e) =>
                                      changeAddItemInputHandler(
                                        "hide_fixed_items",
                                        e?.target?.value
                                      )
                                    }
                                    value={addItemInputForm?.hide_fixed_items}
                                    options={createSelectOptions(
                                      add_item_details?.hide_fixed_items
                                    )}
                                    errorMsg={getErrorMsgForAddItem(
                                      "hide_fixed_items"
                                    )}
                                  />
                                </>
                              )}
                              {addItemInputForm?.menu_item_type ==
                                "standard" && (
                                <>
                                  <GroupSelect
                                    label={"Scan By"}
                                    name="scan_by"
                                    className="required"
                                    divClass="input-group col-md-7"
                                    onChange={(e) =>
                                      changeAddItemInputHandler(
                                        "scan_by",
                                        e?.target?.value
                                      )
                                    }
                                    value={addItemInputForm?.scan_by}
                                    options={createSelectOptions({
                                      Each: "Each",
                                      Weight: "Weight",
                                    })}
                                    errorMsg={getErrorMsgForAddItem("scan_by")}
                                  />
                                  <GroupInput
                                    label={"SKU Code"}
                                    name="sku_code"
                                    className="required"
                                    divClass="input-group col-md-7"
                                    onChange={(e) =>
                                      changeAddItemInputHandler(
                                        "sku_code",
                                        e?.target?.value
                                      )
                                    }
                                    value={addItemInputForm?.sku_code}
                                    errorMsg={getErrorMsgForAddItem("sku_code")}
                                  />
                                </>
                              )}
                            </ul>
                          </div>
                        </div>

                        <div
                          id="tags"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Tags </h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <GroupMultiSelect
                                label={"Select Preference/Allergy Tags"}
                                name="allergy_tags"
                                className="w-100"
                                divClass="input-group col-md-7"
                                onChange={(values) =>
                                  changeAddItemInputHandler(
                                    "allergy_tags",
                                    values
                                  )
                                }
                                value={addItemInputForm?.allergy_tags}
                                options={createMultiSelectOptions(
                                  add_item_details?.allergy_tags
                                )}
                                errorMsg={getErrorMsgForAddItem("allergy_tags")}
                              />
                              <GroupMultiInput
                                label={"Search/Social Media Key Words"}
                                name="key_words"
                                key={new Date().getTime()}
                                className="w-100"
                                divClass="input-group col-md-7 sm-keywords"
                                onItemAdded={(item, allItems) => {
                                  changeAddItemInputHandler("key_words", [
                                    ...addItemInputForm.key_words,
                                    item,
                                  ]);
                                }}
                                onItemDeleted={(item, allItems) => {
                                  changeAddItemInputHandler(
                                    "key_words",
                                    addItemInputForm.key_words.filter(
                                      (p) => p != item
                                    )
                                  );
                                }}
                                values={addItemInputForm?.key_words}
                                errorMsg={getErrorMsgForAddItem("key_words")}
                              />
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="container px-0 d-flex col-12">
                <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                  <button id="cancel" type="button">
                    Cancel
                  </button>
                  <button id="" type="Submit">
                    Save
                  </button>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              {(addItemInputForm?.menu_item_type == "bundled" ||
                addItemInputForm?.menu_item_type == "standard") && (
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">
                          Component Item List
                        </h4>
                      </div>
                    </button>
                  </h2>

                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive">
                            <table className="checklist-table remove-space inventory_table">
                              <thead>
                                {addItemInputForm?.menu_item_type ==
                                "bundled" ? (
                                  <tr>
                                    <th> Option Series </th>
                                    <th> Category </th>
                                    <th> Sub-Category </th>
                                    <th> Menu Item Name </th>
                                    <th> Quantity Per Bundle </th>
                                    <th> Cost Per Bundle </th>
                                    <th> Actions </th>
                                  </tr>
                                ) : (
                                  <tr>
                                    <th> Type </th>
                                    <th> Category </th>
                                    <th> Component Item </th>
                                    <th> Quantity Per Menu Item </th>
                                    <th> Cost Per Menu Item </th>
                                    <th> Proportion of Cost </th>
                                    <th className="action-td"> Actions </th>
                                  </tr>
                                )}
                              </thead>
                              <tbody>{getComponentList()}</tbody>
                            </table>
                          </div>
                          <button
                            class="btn green-btn-revert add-plus addSp"
                            id="addCount"
                            type="button"
                            onClick={() =>
                              addItemInputForm?.menu_item_type == "bundled"
                                ? closeBundledOptionsModal(true)
                                : closeComponentItemModal(true)
                            }
                          >
                            <i class="i-icon"> </i> Add Component Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div class="row">
                <div class="col-md-8">
                  <div class="shadowclass padding_b">
                    <h4 class="event-alert">
                      Service Periods &amp; Lifespan Settings
                    </h4>
                    <div class="row mx-0">
                      <div class="col-md-12">
                        <div class="inner-space screen-scroll mCS_destroyed">
                          <table
                            class="apptable checklist-table remove-space sex-coll"
                            id="TableServicePeriod"
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <thead>
                              <tr>
                                <th> Period Start </th>
                                <th> Period End </th>
                                <th className="action-td"> Actions </th>
                              </tr>
                            </thead>
                            <tbody class="par_service_period">
                              {getServiceItemList()}
                            </tbody>
                          </table>
                          <div class="my-3">
                            <button
                              class="btn green-btn-revert add-plus"
                              id="addPeriod"
                              type="button"
                              onClick={() => closeServiceItemModal(true)}
                            >
                              {" "}
                              <i class="i-icon"> </i> Add Lifespan{" "}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="table-responsive pb-8">
                          <table
                            class="checklist-table remove-space"
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <thead>
                              <tr>
                                <th width="25"></th>
                                <th class="text-left" width="150">
                                  Applicable Period Name
                                </th>
                                <th>Applicable Days</th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(
                                addItemInputForm?.pos_applicable_period
                              ) &&
                                addItemInputForm?.pos_applicable_period.map(
                                  (period, periodInd) => {
                                    const servicePerIndex =
                                      add_item_details?.servicePeriods.findIndex(
                                        (p) =>
                                          p?.id == period?.service_period_id
                                      );
                                    const periodName =
                                      servicePerIndex > -1
                                        ? add_item_details?.servicePeriods?.[
                                            servicePerIndex
                                          ]?.period_name
                                        : "";
                                    const isChecked = period?.is_checked;
                                    return (
                                      <tr>
                                        <td width="15">
                                          <a class="checkbox avaiCheck">
                                            <input
                                              type="checkbox"
                                              name={`PosApplicablePeriod_checkbox_${periodInd}`}
                                              class="avail_checkbox"
                                              checked={isChecked}
                                              onClick={() =>
                                                periodItemChangeInputHandler(
                                                  periodInd,
                                                  "is_checked",
                                                  !isChecked
                                                )
                                              }
                                              value="1"
                                              id={`PosApplicablePeriod${periodInd}IsChecked`}
                                            />{" "}
                                            <label
                                              for={`PosApplicablePeriod${periodInd}IsChecked`}
                                            ></label>
                                          </a>
                                        </td>
                                        <td>{periodName}</td>
                                        <td>
                                          <GroupMultiSelect
                                            label={""}
                                            name={`PosApplicablePeriod_select_${periodInd}`}
                                            className="w-100"
                                            divClass="input-group"
                                            onChange={(values) =>
                                              periodItemChangeInputHandler(
                                                periodInd,
                                                "applicable_days",
                                                values
                                              )
                                            }
                                            value={period?.applicable_days}
                                            options={createMultiSelectOptions(
                                              add_item_details?.weekly
                                            )}
                                            errorMsg={getErrorMsgForComponentItem(
                                              "applicable_days"
                                            )}
                                          />
                                          {/* <div class="input-group select-div mb10">
                                            <div class="ms-parent">
                                              <button
                                                type="button"
                                                class="ms-choice"
                                              >
                                                <span class="placeholder">
                                                  Select
                                                </span>
                                                <div class=""></div>
                                              </button>
                                            </div>{" "}
                                          </div> */}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 menu-price-sec">
                  <div class="shadowclass padding_b">
                    <h4 class="event-alert">Pricing</h4>
                    <div class="inner-space screen-scroll mCS_destroyed">
                      <div class="table-responsive">
                        <table
                          class="checklist-table remove-space sex-coll"
                          id="TablePricing"
                          width="100%"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <thead>
                            <tr>
                              <th> Sales Type &amp; Pricing </th>
                              <th className="action-td"> Actions </th>
                            </tr>
                          </thead>
                          <tbody class="par_pricing">
                            {getPriceItemList()}
                          </tbody>
                        </table>
                      </div>
                      <div class="my-3">
                        <button
                          class="btn green-btn-revert add-plus"
                          id="addPricing"
                          type="button"
                          onClick={() => {
                            dispatch(getMenuEditPricings(`/${id}`));
                            closePriceItemModal(true);
                          }}
                        >
                          {" "}
                          <i class="i-icon"> </i> Add Price Point{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ModelContainer
        title={`Add Component List`}
        open={componentItemModal}
        submitModal={submitComponentItemModal}
        closeModal={closeComponentItemModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <GroupSelect
              label={"Item"}
              name="item_type"
              className="required"
              labelClass="required"
              divClass="input-group"
              onChange={(e) =>
                componentItemChangeInputHandler(
                  selectedComponentItemIndex,
                  "item_type",
                  e?.target?.value
                )
              }
              value={
                addItemInputForm?.component_list_item?.[
                  selectedComponentItemIndex
                ]?.item_type
              }
              empty={"Select Item"}
              options={createSelectOptions(add_item_details?.item_types)}
              errorMsg={getErrorMsgForComponentItem("item_type")}
            />
            {addItemInputForm?.component_list_item?.[selectedComponentItemIndex]
              ?.item_type == "recipe" && (
              <>
                <GroupSelectTwo
                  label={"Recipe"}
                  name="recipe_id"
                  className="required w-100"
                  labelClass="required"
                  divClass="input-group"
                  onSelect={(e) => {
                    componentItemChangeInputHandler(
                      selectedComponentItemIndex,
                      "recipe_id",
                      e?.target?.value
                    );
                  }}
                  value={
                    addItemInputForm?.component_list_item?.[
                      selectedComponentItemIndex
                    ]?.recipe_id
                  }
                  empty={"Select Item"}
                  options={createSelectTwoOptions(add_item_details?.recipes)}
                  errorMsg={getErrorMsgForComponentItem("recipe_id")}
                />
                <GroupInput
                  label={"Number of Servings Used"}
                  name="number_of_servings"
                  className="required"
                  divClass="input-group col-md-7"
                  onChange={(e) =>
                    componentItemChangeInputHandler(
                      selectedComponentItemIndex,
                      "number_of_servings",
                      e?.target?.value
                    )
                  }
                  value={
                    addItemInputForm?.component_list_item?.[
                      selectedComponentItemIndex
                    ]?.number_of_servings
                  }
                  errorMsg={getErrorMsgForComponentItem("number_of_servings")}
                />
                <GroupInput
                  label={"Item Component Cost"}
                  name="item_component_cost"
                  className="required"
                  divClass="input-group col-md-7"
                  readOnly={true}
                  // onChange={(e) =>
                  //   componentItemChangeInputHandler(
                  //     selectedComponentItemIndex,
                  //     "item_component_cost",
                  //     e?.target?.value
                  //   )
                  // }
                  value={
                    addItemInputForm?.component_list_item?.[
                      selectedComponentItemIndex
                    ]?.item_component_cost
                  }
                  errorMsg={getErrorMsgForComponentItem("item_component_cost")}
                />
              </>
            )}
            {addItemInputForm?.component_list_item?.[selectedComponentItemIndex]
              ?.item_type == "ingredient" && (
              <>
                <GroupSelectTwo
                  label={"Ingredient"}
                  name="ingredient_id"
                  className="required w-100"
                  labelClass="required"
                  divClass="input-group"
                  onSelect={(e) =>
                    componentItemChangeInputHandler(
                      selectedComponentItemIndex,
                      "ingredient_id",
                      e?.target?.value
                    )
                  }
                  value={
                    addItemInputForm?.component_list_item?.[
                      selectedComponentItemIndex
                    ]?.ingredient_id
                  }
                  empty={"Select Ingredient"}
                  options={createSelectTwoOptions(
                    add_item_details?.ingredients
                  )}
                  errorMsg={getErrorMsgForComponentItem("ingredient_id")}
                />
                <GroupSelect
                  label={"Measurement Choice"}
                  name="measurement_choice_id"
                  className="required"
                  labelClass="required"
                  divClass="input-group"
                  onChange={(e) =>
                    componentItemChangeInputHandler(
                      selectedComponentItemIndex,
                      "measurement_choice_id",
                      e?.target?.value
                    )
                  }
                  value={
                    addItemInputForm?.component_list_item?.[
                      selectedComponentItemIndex
                    ]?.measurement_choice_id
                  }
                  empty={"Measurement Choice"}
                  options={createSelectOptions(
                    add_item_details?.measurementChoices
                  )}
                  errorMsg={getErrorMsgForComponentItem(
                    "measurement_choice_id"
                  )}
                />
                {addItemInputForm?.component_list_item?.[
                  selectedComponentItemIndex
                ]?.measurement_choice_id == 1 && (
                  <>
                    <GroupSelect
                      label={"Measurement Unit"}
                      name="measurement_unit_id"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        componentItemChangeInputHandler(
                          selectedComponentItemIndex,
                          "measurement_unit_id",
                          e?.target?.value
                        )
                      }
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.measurement_unit_id
                      }
                      empty={"Select"}
                      options={createSelectOptions(
                        measurement_unit_details?.data
                      )}
                      errorMsg={getErrorMsgForComponentItem(
                        "measurement_unit_id"
                      )}
                    />
                    <GroupInput
                      label={"Unit Price"}
                      name="unit_price"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      // onChange={(e) =>
                      //   componentItemChangeInputHandler(
                      //   selectedComponentItemIndex,
                      //     "unit_price",
                      //     e?.target?.value
                      //   )
                      // }
                      disabled={true}
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.unit_price
                      }
                      errorMsg={getErrorMsgForComponentItem("unit_price")}
                    />
                    <GroupInput
                      label={"Unit Amount"}
                      name="unit_amount"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        componentItemChangeInputHandler(
                          selectedComponentItemIndex,
                          "unit_amount",
                          e?.target?.value
                        )
                      }
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.unit_amount
                      }
                      errorMsg={getErrorMsgForComponentItem("unit_amount")}
                    />
                    <GroupInput
                      label={"Item Component Cost"}
                      name="item_component_cost"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      // onChange={(e) =>
                      //   componentItemChangeInputHandler(
                      //   selectedComponentItemIndex,
                      //     "item_component_cost",
                      //     e?.target?.value
                      //   )
                      // }
                      disabled={true}
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.item_component_cost
                      }
                      errorMsg={getErrorMsgForComponentItem(
                        "item_component_cost"
                      )}
                    />
                  </>
                )}
                {addItemInputForm?.component_list_item?.[
                  selectedComponentItemIndex
                ]?.measurement_choice_id == 2 && (
                  <>
                    <h5>Inventory Measurement Amount</h5>
                    <GroupSelect
                      label={"Measurement Unit"}
                      name="temp_measurement_unit_id"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        componentItemChangeInputHandler(
                          selectedComponentItemIndex,
                          "temp_measurement_unit_id",
                          e?.target?.value
                        )
                      }
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.temp_measurement_unit_id
                      }
                      empty={"Select"}
                      options={createSelectOptions(
                        measurement_unit_details?.data
                      )}
                      errorMsg={getErrorMsgForComponentItem(
                        "temp_measurement_unit_id"
                      )}
                    />
                    <GroupInput
                      label={"Unit Price"}
                      name="temp_unit_price"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      // onChange={(e) =>
                      //   componentItemChangeInputHandler(
                      //   selectedComponentItemIndex,
                      //     "temp_unit_price",
                      //     e?.target?.value
                      //   )
                      // }
                      disabled={true}
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.temp_unit_price
                      }
                      errorMsg={getErrorMsgForComponentItem("temp_unit_price")}
                    />
                    <GroupInput
                      label={"Conversion Multiplier"}
                      name="temp_amount_used"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        checkNull(
                          add_item_details?.multiplier_detail?.multiplier,
                          false
                        )
                          ? null
                          : componentItemChangeInputHandler(
                              selectedComponentItemIndex,
                              "temp_amount_used",
                              e?.target?.value
                            )
                      }
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.temp_amount_used
                      }
                      readOnly={
                        checkNull(
                          add_item_details?.multiplier_detail?.multiplier,
                          false
                        )
                          ? true
                          : false
                      }
                      errorMsg={getErrorMsgForComponentItem("temp_amount_used")}
                    />
                    <h5>Menu Item Measurement Amount</h5>
                    <GroupSelect
                      label={"Measurement Unit"}
                      name="measurement_unit_id"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        componentItemChangeInputHandler(
                          selectedComponentItemIndex,
                          "measurement_unit_id",
                          e?.target?.value
                        )
                      }
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.measurement_unit_id
                      }
                      empty={"Select"}
                      options={createSelectOptions(
                        add_item_details?.servingUnits_only_name
                      )}
                      errorMsg={getErrorMsgForComponentItem(
                        "measurement_unit_id"
                      )}
                    />
                    <GroupInput
                      label={"Unit Price"}
                      name="unit_price"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        componentItemChangeInputHandler(
                          selectedComponentItemIndex,
                          "unit_price",
                          e?.target?.value
                        )
                      }
                      readOnly={
                        checkNull(
                          add_item_details?.multiplier_detail?.multiplier,
                          false
                        )
                          ? true
                          : false
                      }
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.unit_price
                      }
                      errorMsg={getErrorMsgForComponentItem("unit_price")}
                    />
                    <GroupInput
                      label={"Amount Used Per Recipe"}
                      name="amount_used"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        componentItemChangeInputHandler(
                          selectedComponentItemIndex,
                          "amount_used",
                          e?.target?.value
                        )
                      }
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.amount_used
                      }
                      errorMsg={getErrorMsgForComponentItem("amount_used")}
                    />
                    <GroupInput
                      label={"Total Cost"}
                      name="item_component_cost"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      // onChange={(e) =>
                      //   componentItemChangeInputHandler(
                      //     selectedComponentItemIndex,
                      //     "item_component_cost",
                      //     e?.target?.value
                      //   )
                      // }
                      disabled={true}
                      value={
                        addItemInputForm?.component_list_item?.[
                          selectedComponentItemIndex
                        ]?.item_component_cost
                      }
                      errorMsg={getErrorMsgForComponentItem(
                        "item_component_cost"
                      )}
                    />
                  </>
                )}
              </>
            )}
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Service Period`}
        open={serviceItemModal}
        submitModal={submitServiceItemModal}
        closeModal={closeServiceItemModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <GroupDate
              label={"Period Start"}
              name="period_start"
              autoComplete="new-password"
              className="required"
              labelClass="required"
              divClass="input-group"
              dateFormat="yyyy-MM-dd"
              onChange={(val) =>
                serviceItemChangeInputHandler(
                  selectedServiceItemIndex,
                  "period_start",
                  val
                )
              }
              selected={
                addItemInputForm?.pos_service_period?.[selectedServiceItemIndex]
                  ?.period_start
              }
              minDate={new Date()}
              errorMsg={getErrorMsgForServiceItem("period_start")}
            />
            <GroupDate
              label={"Period End"}
              name="period_end"
              autoComplete="new-password"
              className="required"
              labelClass="required"
              divClass="input-group"
              dateFormat="yyyy-MM-dd"
              onChange={(val) =>
                serviceItemChangeInputHandler(
                  selectedServiceItemIndex,
                  "period_end",
                  val
                )
              }
              selected={
                addItemInputForm?.pos_service_period?.[selectedServiceItemIndex]
                  ?.period_end
              }
              minDate={
                checkNull(
                  addItemInputForm?.pos_service_period?.[
                    selectedServiceItemIndex
                  ]?.period_start,
                  false
                )
                  ? moment(
                      addItemInputForm?.pos_service_period?.[
                        selectedServiceItemIndex
                      ]?.period_start
                    ).toDate()
                  : new Date()
              }
              errorMsg={getErrorMsgForServiceItem("period_end")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Pricing`}
        open={priceItemModal}
        submitModal={priceItemSubmit(submitPriceItemModal)}
        closeModal={closePriceItemModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <GroupSelect
              label={"Sales Type"}
              name="sales_type_id"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(e) =>
                priceItemChangeInputHandler("sales_type_id", e?.target?.value)
              }
              value={priceItemInputForm?.sales_type_id}
              options={createSelectOptions(add_item_details?.salesType)}
              errorMsg={getErrorMsgForPriceItem("sales_type_id")}
            />
            <GroupInput
              label={"Menu Price ($)"}
              name="menu_price"
              className="required"
              labelClass="required"
              divClass="input-group"
              onChange={(e) =>
                priceItemChangeInputHandler("menu_price", e?.target?.value)
              }
              value={priceItemInputForm?.menu_price}
              errorMsg={getErrorMsgForPriceItem("menu_price")}
            />
            <GroupInput
              label={"Profit (Margin %)"}
              name="profit_margin"
              className="required"
              labelClass="required"
              divClass="input-group"
              placeholder="Profit (Margin)"
              onChange={(e) =>
                priceItemChangeInputHandler("profit_margin", e?.target?.value)
              }
              value={priceItemInputForm?.profit_margin}
              errorMsg={getErrorMsgForPriceItem("profit_margin")}
            />
            <GroupCheckbox
              label={"Sales Tax"}
              name="sales_tax"
              className="avail_checkbox reverse-checkbox"
              onClick={(e) =>
                priceItemChangeInputHandler(
                  "sales_tax",
                  priceItemInputForm?.sales_tax ? 0 : 1
                )
              }
              checked={priceItemInputForm?.sales_tax == 1 ? true : false}
              value={1}
              errorMsg={getErrorMsgForPriceItem("sales_tax")}
            />
            <GroupCheckbox
              label={"Service Charge"}
              name="service_charge"
              className="avail_checkbox reverse-checkbox"
              onClick={(e) =>
                priceItemChangeInputHandler(
                  "service_charge",
                  priceItemInputForm?.service_charge ? 0 : 1
                )
              }
              checked={priceItemInputForm?.service_charge == 1 ? true : false}
              value={1}
              errorMsg={getErrorMsgForPriceItem("service_charge")}
            />
            <GroupColorInput
              label={"Button Color"}
              name="button_color"
              labelClass="required"
              divClass="input-group"
              onChange={(e) =>
                priceItemChangeInputHandler("button_color", e?.target?.value)
              }
              value={priceItemInputForm?.button_color}
              errorMsg={getErrorMsgForPriceItem("button_color")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Bundled Menu Item Component`}
        open={bundledOptionsModal}
        submitModal={submitBundledOptionsModal}
        closeModal={closeBundledOptionsModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <GroupSelect
              label={"Select Option Series"}
              name="option_series"
              className="required"
              labelClass="required"
              divClass="input-group col-md-7"
              onChange={(e) =>
                bundledOptionsChangeInputHandler(
                  selectedBundledOptionsIndex,
                  "option_series",
                  e?.target?.value
                )
              }
              value={
                addItemInputForm?.bundled_option_series?.[
                  selectedBundledOptionsIndex
                ]?.option_series
              }
              options={createSelectOptions(add_item_details?.option_series)}
              errorMsg={getErrorMsgForBundledOptions("option_series")}
            />
            {addItemInputForm?.bundled_option_series?.[
              selectedBundledOptionsIndex
            ]?.option_series == "new" && (
              <>
                <GroupSelect
                  label={"Option Series Type"}
                  name="option_series_type"
                  className="required"
                  labelClass="required"
                  divClass="input-group col-md-7"
                  onChange={(e) =>
                    bundledOptionsChangeInputHandler(
                      selectedBundledOptionsIndex,
                      "option_series_type",
                      e?.target?.value
                    )
                  }
                  value={
                    addItemInputForm?.bundled_option_series?.[
                      selectedBundledOptionsIndex
                    ]?.option_series_type
                  }
                  options={createSelectOptions({
                    ms: "Must Select",
                    sut: "Select Up To",
                  })}
                  errorMsg={getErrorMsgForBundledOptions("option_series_type")}
                />
                <GroupInput
                  label={"Option Series Name"}
                  name="option_series_name"
                  className="required"
                  labelClass="required"
                  divClass="input-group"
                  placeholder="Option Series Name"
                  onChange={(e) =>
                    bundledOptionsChangeInputHandler(
                      selectedBundledOptionsIndex,
                      "option_series_name",
                      e?.target?.value
                    )
                  }
                  value={
                    addItemInputForm?.bundled_option_series?.[
                      selectedBundledOptionsIndex
                    ]?.option_series_name
                  }
                  errorMsg={getErrorMsgForBundledOptions("option_series_name")}
                />
                <GroupSelect
                  label={"Series Total Allowed"}
                  name="series_total_allowed"
                  className="required"
                  labelClass="required"
                  divClass="input-group col-md-7"
                  onChange={(e) =>
                    bundledOptionsChangeInputHandler(
                      selectedBundledOptionsIndex,
                      "series_total_allowed",
                      e?.target?.value
                    )
                  }
                  value={
                    addItemInputForm?.bundled_option_series?.[
                      selectedBundledOptionsIndex
                    ]?.series_total_allowed
                  }
                  options={createSelectOptions(
                    add_item_details?.series_allowed
                  )}
                  errorMsg={getErrorMsgForBundledOptions(
                    "series_total_allowed"
                  )}
                />
              </>
            )}
            <GroupSelect
              label={"Menu Item Category"}
              name="category_id"
              className="required"
              labelClass="required"
              divClass="input-group col-md-7"
              onChange={(e) =>
                bundledOptionsChangeInputHandler(
                  selectedBundledOptionsIndex,
                  "category_id",
                  e?.target?.value
                )
              }
              value={
                addItemInputForm?.bundled_option_series?.[
                  selectedBundledOptionsIndex
                ]?.category_id
              }
              options={createSelectOptions(add_item_details?.otherCategories)}
              errorMsg={getErrorMsgForBundledOptions("category_id")}
            />
            <GroupSelect
              label={"Menu Item Sub-category"}
              name="sub_category_id"
              className="required"
              labelClass="required"
              divClass="input-group col-md-7"
              onChange={(e) =>
                bundledOptionsChangeInputHandler(
                  selectedBundledOptionsIndex,
                  "sub_category_id",
                  e?.target?.value
                )
              }
              value={
                addItemInputForm?.bundled_option_series?.[
                  selectedBundledOptionsIndex
                ]?.sub_category_id
              }
              options={createSelectOptions(item_subcategory_detail)}
              errorMsg={getErrorMsgForBundledOptions("sub_category_id")}
            />
            <GroupMultiSelect
              label={"Menu Item Name"}
              name="bundle_menu_item_id"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(values) =>
                bundledOptionsChangeInputHandler(
                  selectedBundledOptionsIndex,
                  "bundle_menu_item_id",
                  values
                )
              }
              value={
                addItemInputForm?.bundled_option_series?.[
                  selectedBundledOptionsIndex
                ]?.bundle_menu_item_id
              }
              multiple={!checkNull(editBundledOption, false)}
              options={createMultiSelectOptions(menu_item_list)}
              errorMsg={getErrorMsgForBundledOptions("bundle_menu_item_id")}
            />
            <GroupInput
              label={"Quantity Per Bundle"}
              name="quantity"
              disabled={
                !checkArray(
                  addItemInputForm?.bundled_option_series?.[
                    selectedBundledOptionsIndex
                  ]?.bundle_menu_item_id
                )
              }
              className="required"
              labelClass="required"
              divClass="input-group"
              onChange={(e) =>
                bundledOptionsChangeInputHandler(
                  selectedBundledOptionsIndex,
                  "quantity",
                  e?.target?.value
                )
              }
              onBlur={(e) => getCostPerItemPrices()}
              value={
                addItemInputForm?.bundled_option_series?.[
                  selectedBundledOptionsIndex
                ]?.quantity
              }
              errorMsg={getErrorMsgForBundledOptions("quantity")}
            />
            <GroupSelect
              label={"Additional/Reduced Price for Component"}
              name="action_price"
              className="required"
              labelClass="required"
              divClass="input-group col-md-7"
              onChange={(e) =>
                bundledOptionsChangeInputHandler(
                  selectedBundledOptionsIndex,
                  "action_price",
                  e?.target?.value
                )
              }
              value={
                addItemInputForm?.bundled_option_series?.[
                  selectedBundledOptionsIndex
                ]?.action_price
              }
              options={createSelectOptions(add_item_details?.price_action)}
              errorMsg={getErrorMsgForBundledOptions("action_price")}
            />
            {checkNull(
              addItemInputForm?.bundled_option_series?.[
                selectedBundledOptionsIndex
              ]?.action_price,
              false
            ) && (
              <GroupInput
                label={"Amount"}
                name="amount"
                className="required"
                labelClass="required"
                divClass="input-group"
                onChange={(e) =>
                  bundledOptionsChangeInputHandler(
                    selectedBundledOptionsIndex,
                    "amount",
                    e?.target?.value
                  )
                }
                value={
                  addItemInputForm?.bundled_option_series?.[
                    selectedBundledOptionsIndex
                  ]?.amount
                }
                errorMsg={getErrorMsgForBundledOptions("amount")}
              />
            )}

            <GroupSelect
              label={"Availability of Component's Modifiers"}
              name="modifier_availability"
              className="required"
              labelClass="required"
              divClass="input-group col-md-7"
              onChange={(e) =>
                bundledOptionsChangeInputHandler(
                  selectedBundledOptionsIndex,
                  "modifier_availability",
                  e?.target?.value
                )
              }
              value={
                addItemInputForm?.bundled_option_series?.[
                  selectedBundledOptionsIndex
                ]?.modifier_availability
              }
              options={createSelectOptions(
                add_item_details?.modifier_availability_options
              )}
              errorMsg={getErrorMsgForBundledOptions("modifier_availability")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Storage Area`}
        open={storageAreaModalModal}
        submitModal={submitStorageAreaModal}
        closeModal={closeStorageAreaModal}
        is_loading={is_add_storage_loading}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <li>
              Storage Area
              <div class="input-group">
                <input
                  name="data[storage_area]"
                  class="required"
                  type="text"
                  id="storage_area"
                  onChange={(e) => setStorageAreaInput(e?.target?.value)}
                  value={storageAreaInput}
                />
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>
    </>
  );
};

export default MenuItem;
